import {
  AfterViewChecked,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';

import {
  DrillPointsParams, LMActionRequest,
  LMComponentInfoService,
  LMDrillService,
  LMLoggerService,
  LMUrlInfoBuilderService,
  LMListFilterPersistenceService
} from '@services/index';
import { LMBannerHeaderComponentRef } from '@banner/lm-banner-header-component-ref.service';
import { AppConstants, LMDialogButtonKey, LMFormType, LMTransformOptions, LMUniqueIdService } from '@utils/index';
import {
  LMModel,
  LMModelCache,
  LMModelField,
  LMModelServiceAdapter,
  LMModelStatusEvent
} from './model';
import { FormResource, KeyedResource, ListResource, RelationResource } from '@resources/index';
import { LMBaseFormComponent, LMDialogInfo, LoadResponse } from '@base/index';
import { LMFormToolbarService } from '@form/services';
import { LMErrorUtilService, LMFormatUtilService, LMFieldUtilService } from '@services/utils/index';
import { LMFormActionUtilService, LMFormContext } from './services/lm-form-action-util.service';
import { LMFormStateKeyParams, LMFormStateService } from '@states/services/lm-form-state.service';
import {
  LMFormPersonalizationKeyParams,
  LMFormPersonalizationService
} from '@states/services/lm-form-personalization.service';
import { LMFormState } from '@states/models/lm-form-state.model';
import { LMFormPersonalization } from '@states/models/lm-form-personalization.model';
import { LMFormPagingService } from '@form/services/lm-form-paging.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMFormTransactionService } from './services/lm-form-transaction.service';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMCheckControlEvent } from '@field/checkcontrol/lm-checkcontrol.component';
import { LMButtonEvent } from '@field/button/lm-button.component';
import { LMSpecService } from '@services/lm-spec.service';
import { LMFormService } from '@form/services/lm-form.service';
import {
  LMActionFormDialogResult,
  LMActionFormDialogResultCode,
  LMActionFormDialogService
} from '@modal/lm-action-form-dialog.service';
import { LMPrintDialogService, LMPrintPdfInfo } from '@modal/print-dialog/lm-print-dialog.service';
import { LMActionService } from '@services/lm-action.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMFormContentComponent } from './lm-form-content.component';
import { LMTextEvent } from '@field/text/lm-text.component';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMFormRequestService } from '@form/services';
import {
  SohoBusyIndicatorDirective,
  SohoMessageService,
  SohoModalDialogService
} from 'ids-enterprise-ng';
import * as _ from 'lodash';
import { SaveRequired } from '@base/lm-base';
import { LMActionFormDialogComponent } from '@modal/lm-action-form-dialog.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import {
  LMCompactFormEvent,
  LMCubeRelationLPLValidationEvent,
  LMDefineEvent,
  LMFieldValueChangedEvent,
  LMInvalidLPLEvent,
  LMPreviewEvent,
  LMQueryValidateEvent,
  LMRelatedFormEvent,
  LMSubFormEvent,
  LMTranslateFormEvent
} from '@field/lm-field-base.component';
import { LMMenuEvent } from '@card/lm-simple-card.component';
import { LMFormManualRepService } from './lm-form-manual-rep.service';
import { LMHtmlPageUtilService } from '@html/lm-html-page-util.service';
import { LMGlobalPersonalizationService } from '@states/services/lm-global-personalization.service';
import {
  LMCompactFormDialogResult,
  LMCompactFormDialogService,
  LMCompactFormResult
} from '@modal/lm-compact-form-dialog.service';
import { LMContextService } from '@services/lm-context.service';
import { LMTransactionService, LMTransactionState } from '@transaction/index';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { LMSubFormDialogResult, LMSubFormDialogService, LMSubFormResult } from '@modal/lm-sub-form-dialog.service';
import {
  LMSelectRecordDialogResult,
  LMSelectRecordDialogService,
  LMSelectRecordResult
} from '@modal/lm-select-record-dialog.service';
import { DocumentResource } from '@resources/document.resource';
import { LMFieldOptionsService, LMFieldOptionsToolbarService } from '@field/services';
import { LMInstanceCountChartEvent } from './lm-form-content-instance-count.component';
import {
  DefineFormSpecUrlResponse,
  LMFormSpecUtilService,
  LMPanelTransactionEvent,
  LMStepPanelEvent
} from './services';
import {
  LMFieldSubscriptionService,
  LMManualRepresentationComponent,
  LMOpenLookupEvent,
  LMPreviewOptionsDialogComponent
} from '@field/index';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMListComponent } from '@list/lm-list.component';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, Observer, SubscriptionLike as ISubscription, throwError, Subject } from 'rxjs';
import { debounceTime, filter, first, flatMap, catchError, finalize, concatMap, tap } from 'rxjs/operators';
import { LMAuditLogCompareDialogComponent } from '@auditlog/lm-audit-log-compare-dialog.component';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { LMPrintCsvInfo, LMScheduleDialogService } from '@modal/print-dialog';
import { LMGlobalStorageKeyParams, LMGlobalStorageService } from '@states/services';
import { LMGlobalStorageModel } from '@states/models';
import { LMStateHelperService } from '@services/lm-state-helper.service';
import { LMKeyboardShortcutService, LMKeyType } from '@services/lm-keyboard-shortcut.service';

import * as urltemplate from 'url-template';
import { LMHtmlUrlDocService } from '@services/lm-html-url-doc.service';
import { LMHtmlUrlDocComponent } from '@app/components';
import { LMAppComponentService } from '@utils/lm-app-component.service';

export class LMFormTransactionEvent {
  public constructor(
    public eventSource: LMFormComponent,
    public actionResultArray: LMActionResult) {}
}

class FormViewData {
  /**
   * Set this formSpec to have the view template pass list spec down
   * to the form-content.component and it's sub view  (standard, composite, etc...)
   */
  formSpec: LMFormSpec;
  /**
   * Set this dataView to have the view template pass dataView down
   * to the form-content.component and it's sub view  (standard, composite, etc...)
   */
  dataView: LMDataView;
}

@Component({
  selector: 'lm-form',
  providers: [
    LMDrillService,
    LMFieldOptionsService,
    LMFieldOptionsToolbarService,
    LMFieldSubscriptionService,
    LMFormActionUtilService,
    LMFormPagingService,
    LMFormService,
    LMFormToolbarService,
    LMKeyboardShortcutService,
    LMModelServiceAdapter,
    LMFormManualRepService,
    LMHtmlPageUtilService,
    LMHtmlUrlDocService,
    LMSelectRecordDialogService
  ],
  templateUrl: './lm-form.component.html',
  styleUrls: [ 'lm-form.component.scss' ]
})

export class LMFormComponent extends LMBaseFormComponent implements OnInit, AfterViewChecked, OnDestroy, SaveRequired {
  // todo: don't really like this as it just hides the component. Values from the screen are still in the dom but just not displayed.
  // todo: we'll also want to put a semi-opaque overlay over the form so no toolbar buttons can be clicked.
  @HostBinding('style.visibility') get hostVisibility() {
    if (this.formSpec) {
      return this.formSpec.dependentForm && (this.fromDataView === null && this.initDataView === null) ? 'hidden' : null;
    }
    return null;
  }

  @HostBinding('style.height') styleHeight = '100%';
  @HostBinding('style.display') styleDisplay = 'block';

  @HostBinding('id') get formId(): string {
    if (this.formSpec) {
      return this.formSpec.formElementId + (this.testVersion1 ? '' : '_form');
    }
    return null;
  }

  @HostBinding('class.lm-banner-in-route') get classBannerInRoute() {
    return this.bannerInRoute;
  }

  @HostBinding('attr.data-automation-id') get formAutomationId(): string {
    if (this.formSpec) {
      return `lm-${this.formSpec.automationId}-form`;
    }
    return null;
  }

  @HostListener('document:keydown', [ '$event' ]) onKeyDown(e) {
    // TODO check to make sure a modal isn't open.
    if (this.isRouterOutletRootComponent) {
      const key = this.lmKeyboardShortcutService.onKeyDown(e);
      if (!key) {
        return;
      }
      const dataView: LMDataView = this.getDataView();

      switch (key) {
        case LMKeyType.SAVE:
          if (this.checkSaveRequired()) {
            this.runSave(AppConstants.STANDARD_SAVE, dataView);
          }
          break;
        case LMKeyType.NEXT:
          if ((this.lmFormSpecUtilService.isStandardForm(this.formSpec)
              || this.lmFormSpecUtilService.isCompositeForm(this.formSpec))
            && !this.lmFormSpecUtilService.isActionForm(this.formSpec)) {
            if (dataView.pagingInfo && dataView.pagingInfo.hasNext && !dataView.pagingInfo.nextDisabled) {
              this.getNextRecord(dataView);
            }
          }
          break;
        case LMKeyType.PREVIOUS:
          if ((this.lmFormSpecUtilService.isStandardForm(this.formSpec)
              || this.lmFormSpecUtilService.isCompositeForm(this.formSpec))
            && !this.lmFormSpecUtilService.isActionForm(this.formSpec)) {
            if (dataView.pagingInfo && dataView.pagingInfo.hasPrevious && !dataView.pagingInfo.previousDisabled) {
              this.getPreviousRecord(dataView);
            }
          }
          break;
        case LMKeyType.REFRESH:
          this._runRefresh();
          break;
      }
    }
  }

  @ViewChild('LMFormContentComponent') formContentComponent: LMFormContentComponent;
  @ViewChild('dialogPlaceholder', { read: ViewContainerRef, static: true }) placeHolder: ViewContainerRef;
  @ViewChild(LMToolbarComponent) lmToolbarComponent: LMToolbarComponent;
  @ViewChild(SohoBusyIndicatorDirective) sohoBusyIndicator: SohoBusyIndicatorDirective;

  @Input() actionIsAction: string;
  @Input() resourceId: string;
  @Input() formUrlInfo: LMFormUrlInfo = null;
  @Input() formSpec: LMFormSpec = null;
  @Input() actionFormOptions: LMActionFormOptions;
  @Input() parentIsModal: boolean;
  @Input() isCartView: boolean;
  @Input() hideLayout = false;
  private _formOptions: LMFormOptions = {};
  @Input() set formOptions(options: LMFormOptions) {
    // Allows the form to be aware of filterCriteria changes to update the model accordingly
    const filterCriteria = options.filterCriteria;
    if (this.model
      && this._initDataView
      &&  this._formOptions.filterCriteria !== filterCriteria
      &&  (this._formOptions.filterCriteria || filterCriteria)) {
      this.model.setData(this._initDataView, { filterCriteria, alphaDefaultFilterCondition: options.defaultAlphaFilterCondition });
    }
    this._formOptions = options;
  }
  get formOptions(): LMFormOptions {
    return this._formOptions;
  }

  @Input() set specFields(specFields: LMSpecFields) {
    this._specFields = specFields;
  }

  get specFields(): LMSpecFields {
    return this._specFields;
  }

  @Input() set initDataView(dataView: LMDataView) {
    if (!dataView) {
      return;
    }

    this.lmLoggerService.log([ this, this.instanceId, 'initDataView()' ]);
    this._initDataView = dataView;

    if (this.initialBuildComplete) {
      this.formDataLoaded();
    }
  }

  @Input() set fromDataView(dataView: LMDataView) {
    this._fromDataView = dataView;
    this.fromDataViewChanged = true;
  }
  get fromDataView(): LMDataView {
    return this._fromDataView;
  }

  @Input() columnarText: string;
  @Input() pageContextForm = false;

  @Output() contentModified = new EventEmitter<any>();
  @Output() cubeSearchOpenLookupEvent = new EventEmitter<LMFieldEvent>();
  @Output() searchButtonClicked = new EventEmitter<LMFilterEvent>();
  @Output() clearSearchButtonClicked = new EventEmitter<LMFilterEvent>();
  @Output() formRendered = new EventEmitter<any>();
  @Output() titleChanged = new EventEmitter<any>();
  @Output() sendContextMessageEvent = new EventEmitter<any>();
  @Output() formDisplayed = new EventEmitter<any>();
  @Output() formTransactionEvent = new EventEmitter<LMFormTransactionEvent>();
  @Output() fieldEvent = new EventEmitter<LMFieldEvent>();
  @Output() appMenuTriggerEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  private fromDataViewChanged = false;
  private _initDataView: LMDataView;
  private _fromDataView: LMDataView | null = null;
  private fromResourceImpl: KeyedResource;
  private formResourceImpl: FormResource;

  private formComponentId: string;

  private formDataLoadedComplete: boolean;
  public isRouterOutletRootComponent = false;
  private formType: LMFormType = LMFormType.STANDARD;

  // private verticalTabs = false;
  // private contextForm: LMContextForm;
  // private isPanelNavigation = false;
  // private isWizard = false;

  public _specFields: LMSpecFields;
  private configRequiredFields: Array<string>;
  public layout: LMFormLayout;
  public model: LMModel;
  public events: any[] = [];

  public hideTitleBar = false;
  public hideTitleManageScroll = false;
  public testVersion1: boolean;
  public uiLoadingIndicatorTimeout = 0;

  // false indicates form is pristine; no modifications
  public allowUpdate = false;

  public isProduction = environment.production;
  private modelSourceEvent: LMModelSourceEvent;
  private toolbarInitialized = false;
  private hasModelStatusSubscription = false;
  private showMatrixDetail = false;
  private lookupFieldId: string;
  private runningSpecialActionList: LMListComponent;
  public bannerInRoute = false;

  public compositeFormWithOutContext = false;

  get formModel(): LMModel {
    return this.model;
  }

  // Toolbar
  public formTitle: string;
  public toolbarButtons: Observable<Array<LMToolbarButton>>;

  /**
   * Hold the state of this form.
   */
  public formState: LMFormState = {};
  private formStateKeyParams: LMFormStateKeyParams;

  public formPersonalization: LMFormPersonalization = {};
  private formPersonalizationKeyParams: LMFormPersonalizationKeyParams;

  private globalStorageModel: LMGlobalStorageModel = {};
  private globalStorageKeyParams: LMGlobalStorageKeyParams;

  private anonymousRegistered = false;
  private modelCache: LMModelCache;

  private initialBuildComplete = false;
  private subscriptionArray: Array<ISubscription> = [];

  public locale = 'en-US';
  public formViewData: FormViewData = new FormViewData();

  private hasLPLValidationError = false;
  private scheduleView: LMDataView;
  private initialValueRuleCallQueue$ = new Subject();
  public readonly instanceId: string;
  private stepUpActionResult: LMActionResult;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private zone: NgZone,
    private changeDetectionRef: ChangeDetectorRef,
    private currentComponent: LMRouteComponentService,
    public elementRef: ElementRef,
    private location: Location,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private sohoMessageService: SohoMessageService,
    public sohoModalDialogService: SohoModalDialogService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmContextService: LMContextService,
    @Inject(forwardRef(() => LMActionFormDialogService)) private lmActionFormDialogService, // LMActionFormDialogService,
    private lmActionService: LMActionService,
    private lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    private lmCompactFormDialogService: LMCompactFormDialogService,
    private lmSubFormDialogService: LMSubFormDialogService,
    private lmSelectRecordDialogService: LMSelectRecordDialogService,
    private lmConditionUtilService: LMConditionUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmFormActionUtilService: LMFormActionUtilService,
    private lmFormPersonalizationService: LMFormPersonalizationService,
    private lmFormPagingService: LMFormPagingService,
    private lmStateHelperService: LMStateHelperService,
    private lmFormStateService: LMFormStateService,
    private lmFormService: LMFormService,
    private lmFormSpecUtilService: LMFormSpecUtilService,
    private lmFormRequestService: LMFormRequestService,
    private lmFormToolbarService: LMFormToolbarService,
    private lmFormTransactionService: LMFormTransactionService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmListFilterPersistenceService: LMListFilterPersistenceService,
    private lmGlobalStorageService: LMGlobalStorageService,
    private lmHtmlPageUtilService: LMHtmlPageUtilService,
    protected lmLoggerService: LMLoggerService,
    private lmModelServiceAdapter: LMModelServiceAdapter,
    private lmNavigationService: LMNavigationService,
    private lmPrintDialogService: LMPrintDialogService,
    private lmSpecService: LMSpecService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmContextUtilService: LMContextUtilService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private lmKeyboardShortcutService: LMKeyboardShortcutService,
    private lmTransactionService: LMTransactionService,
    private lmFieldUtilService: LMFieldUtilService,
    private lmScheduleDialogService: LMScheduleDialogService,
    private lmHtmlUrlDocService: LMHtmlUrlDocService,
    protected lmAppComponentService: LMAppComponentService
  ) {
    super(sohoModalDialogService, lmBusyIndicatorService, lmLoggerService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService);
    this.initializeMemberVariables();
    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;

    //  This is added for now to get by an issue where the preceived loading of the component is delayed.
    //  The constructor is called but then a 4-10 second delay is seen before the ngOnInit is called.
    //  The issue was written up but the issue closed as no example was submitted and the problem was not
    //  seen by a large number of people. Current plan is to try to dup the issue in a small example and
    //  submit. A link to the issue Below
    //  https://github.com/angular/angular/issues/18816
    setTimeout(() => {
      this.zone.run(() => {
        // CHANGE DETECTION
        if (this.url3_5) {
          this.changeDetectorRef.detectChanges();
        }
      });
    });

    const routerEventsSubscription = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // this.currentComponent.setRouteComponent(<Component>this);
        // if (this.isRouterOutletRootComponent && this.initialBuildComplete) {
        //   /**
        //    * Called when this ListComponent object is reused by angular.
        //    * Call resetListComponent and build here as ngOnInit and ngAfterViewInit
        //    * will not be called in this scenarios.
        //    */
        //   this.resetFormComponent();
        //   this.showBusyIndicator();
        //   this.build();
        // }
        // // setTimeout(() => {
        // //   appRef.tick();
        // // });
      } else if (event instanceof NavigationStart) {

        // show busy indicator when leaving a route.
        this.lmBusyIndicatorService.showBusyIndicator();

        // ---------------------------------------------------------------------
        // NOTE: if an access denied error happens then page won't be built.
        // Make sure to only saveState and personalizations if the component
        // is actually built.
        // ---------------------------------------------------------------------
        if (this.initialBuildComplete) {
          this.saveComponentState();
        }
      }
    });

    this.instanceId = this.lmLoggerService.instanceId;
    this.subscriptionArray.push(routerEventsSubscription);
  }

  // events
  ngOnInit() {
    this.lmLoggerService.time({
      id: `Total-Form-${this.instanceId}`,
      description: 'TOTAL FORM',
      functionName: 'ngOnInit()',
      className: 'LMFormComponent',
      timingStart: 'LMFormComponent -> ngOnInit()',
      timingEnd: 'LMFormContentComponent -> ngAfterViewInit()'
    });

    this.lmLoggerService.log([ this, this.instanceId, 'ngOnInit()' ]);
    this.lmLoggerService.trace([ this, this.instanceId, 'ngOnInit()', 'resourceId=', this.resourceId, 'formSpec=', this.formSpec ]);

    this.testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;

    this.bannerInRoute = this.lmContextService.isBannerInRoute();
    this.hideTitleBar = this.bannerInRoute ? true : this.lmContextService.isHideTitlebar();

    if (!this.lmContextService.inMingleWidget() && !this.lmContextService.inMingleInbox() && !this.formSpec) {
      this.isRouterOutletRootComponent = true;
      this.currentComponent.setRouteComponent(this as Component);
    }

    this.showBusyIndicator();

    if (!this.initialBuildComplete) {
      this.build();
    }

    // this code block will handle synchronous firing of initial value rule (queue schduler)
    // it will queue events until its MAX_QUEUE, set from LMFormService, equals 2
    this.initialValueRuleCallQueue$.pipe(
      tap(() => {
        this.lmFormService.initialValueRuleQueueCountUp();
        if (!this.lmFormService.canFireIntialValueRule) {
          this.showBusyIndicator();
        }
      }),
      concatMap((bindId: string) => this.fireInitialValueRules(bindId))
    ).subscribe(() => {
      // TODO DPB need to notify listeners like step and composite so they can update tab if a visibleWhen condition was updated
      this.lmFormService.initialValueRuleQueueCountDown();
      this.lmConditionUtilService.evaluateConditions.next(true);
      if (!this.lmFormService.isFiringInitialValueRule) {
        this.hideBusyIndicator();
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  ngAfterViewChecked() {
    if (this.componentDestroyed) {
      return;
    }

    if (this.fromDataViewChanged) {
      this.fromDataViewChanged = false;

      // An independent form on a composite form panel
      // sets the fromDataView to null when the composite form
      // dataView keys change. It does this so the component will
      // not fetch data until its the active panel.
      if (this.fromDataView != null) {
        setTimeout(() => this.load());
      }
    }
  }

  ngOnDestroy() {
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
    this.lmFormToolbarService.reset();

    this.setComponentDestroyed();
    this.initialValueRuleCallQueue$.complete();

    // added to try to fix memory leak in IE11 when using the harness
    this.lmBannerHeaderCompRef = null;
    this.toolbarMoreMenuSettings = null;
    this.onBeforeFormToolbarMoreMenuOpen = null;

    // maf trying this here first; remove if there are issues
    // maf found issues 08/08/2019 model cannot be destroyed due to applying state changes from sub / compact form
    // if (this.model) {
    //   this.model.destroy();
    //   this.model = null;
    // }
  }

  public allowPageNavigation(): Promise<boolean> | boolean {
    if (this.checkSaveRequired()) {
      if (this.modalOpen()) {
        // let just ask if they want to stay,
        // difficult to determine the modal's purpose - it may run an action or it may just return unsaved data
        return this.displayNavigationConfirmation();
      } else {
        const youMayNavigateSource = new BehaviorSubject<boolean>(false);
        const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();

        const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg')  };
        this.handleUnsavedChanges(info).subscribe(continueOn => {
          youMayNavigateSource.next(continueOn);
          youMayNavigateSource.complete();
          this.hideBusyIndicator();
        });

        return youMayNavigate.pipe(filter(el => el)).toPromise();
      }
    }
    return true;
  }

  private handleUnsavedChanges(info: LMDialogInfo): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (this.isModified()) {
        this.showUnsavedChanges(info).subscribe((response: UnsavedChangesResponse) => {
          if (response === LMDialogButtonKey.YES) {
            const dataView: LMDataView = this.getDataView();
            this.runSave(AppConstants.STANDARD_SAVE, dataView, observer);
          } else if (response === LMDialogButtonKey.NO) {
            observer.next(true);
            observer.complete();
          } else {
            // Cancel.  Stay put and do nothing!
            observer.next(false);
            observer.complete();
          }
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  checkSaveRequired() {
    if (this.anonymousRegistered) {
      return false; // anonymous user registered and now has an actorId. the window will reload!!!
    }
    if (this.modelCache && this.modelCache.autoApply === true) {
      return false;
    }
    return (this.isModified() || this.modalOpen());
  }

  modalOpen() {
    return this.lmActionFormDialogService.hasOpenDialog;
  }

  displayNavigationConfirmation(): Promise<boolean> | boolean {
    const comp: LMActionFormDialogComponent = this.lmActionFormDialogService.getOpenDialog.componentDialog;
    const youMayNavigateSource = new BehaviorSubject<boolean>(false);
    const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();
    const dialogId = 'UnsavedChanges';
    if (comp.formComponent.isModified()) {
      const buttons = [
        // tslint:disable-next-line - shadowed variable e
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.LEAVE ]),
          text: Soho.Locale.translate(LMDialogButtonKey.LEAVE),
          click: (e, modal) => {
            this.lmActionFormDialogService.getOpenDialog.close(<LMActionFormDialogResult>{ result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_CANCEL });
            youMayNavigateSource.next(true);
            youMayNavigateSource.complete();
            modal.close();
          }
        },
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.STAY ]),
          text: Soho.Locale.translate(LMDialogButtonKey.STAY),
          click: (e, modal) => {
            youMayNavigateSource.next(false);
            youMayNavigateSource.complete();
            modal.close();
            this.hideBusyIndicator();
          }
        }
      ];

      // Show the confirmation message dialog.
      // todo I18n
      this.sohoMessageService
        .message()
        .message(Soho.Locale.translate('NavigateAwayMessage'))
        .title(Soho.Locale.translate('UnsavedChangesMessage'))
        .buttons(buttons)
        .open();

    } else {
      // the form in the action form dialog component isn't dirty, so just return a boolean rather than
      // a promise attached to a confirmation
      this.lmActionFormDialogService.getOpenDialog.close();
      return true;
    }

    return (youMayNavigate.pipe(filter(el => el))).toPromise();
  }

  showBusyIndicator(): void {
    if (this.isRouterOutletRootComponent) {
      this.lmBusyIndicatorService.showBusyIndicator();
    }
  }

  hideBusyIndicator(): void {
    if (this.isRouterOutletRootComponent) {
      this.lmBusyIndicatorService.hideBusyIndicator();
    }
  }

  private initializeMemberVariables() {
    this.formDataLoadedComplete = false;
    this.formSpec = undefined;
    this.formOptions = { isDashBoardContent: false };
    this.formViewData = new FormViewData();
    this.formType = LMFormType.STANDARD;

    this.resourceId = '';
    this._initDataView = undefined;
    this.fromResourceImpl = undefined;
    this.formResourceImpl = undefined;

    this.formComponentId = undefined;

    this._specFields = undefined;
    this.configRequiredFields = [];
    this.layout = undefined;
    this.model = undefined;
    // this.form = undefined;

    this.events = [];

    // false indicates form is pristine; no modifications
    this.allowUpdate = false;

    // Toolbar
    this.formTitle = '';
    this.lmFormToolbarService.reset();

    /**
     * Hold the state of this form.
     */
    this.formState = {};
    this.formStateKeyParams = null;
    this.formPersonalization = {};
    this.formPersonalizationKeyParams = null;
    this.globalStorageModel = {};
    this.globalStorageKeyParams = null;
    this.modelCache = undefined;
  }

  /**
   * Reset this LMFormComponent so it can be re-used for another formSpec.
   */
  /*  private resetFormComponent() {
    this.initializeMemberVariables();

    // reset the header toolbar if this is the root router-outlet component
    if (this.isRouterOutletRootComponent) {
      this.lmBannerHeaderCompRef.instance.hasTabs = false;
      this.lmFormToolbarService.reset();
    }

    this.url3_5 = undefined;
    this.legacyWebUI = false;
    this.uiCompare = false;
  }*/

  private isMingleEnabledForShortcut(): boolean {
    return (!this.isActionForm &&
      !this.isChangePasswordForm &&
      !this.isBusinessTaskForm &&
      !this.isSearchForm &&
      !this.isPageContextForm &&
      !this.isResponseRequired &&
      !this.isCompactForm &&
      !this.formOptions.isDashBoardContent &&
      !this.formSpec.dependentForm);
  }

  private isMingleEnabledForBusinessContext(): boolean {
    // Process flow work item forms displayed in Mingle inbox are not of the following types tested. This method will return true.
    return (!this.isChangePasswordForm &&
      !this.isSearchForm &&
      !this.isPageContextForm &&
      !this.isResponseRequired &&
      !this.isCompactForm &&
      !this.formOptions.isDashBoardContent &&
      !this.formSpec.dependentForm);
  }

  private sendShortcut(): void {
    if (this.isMingleEnabledForShortcut()) {
      this.lmContextUtilService.enableStandardShortcut();
    }
  }

  private sendBusinessContext(dataView: LMDataView, contextMsgs?: any): void {
    if (this.isMingleEnabledForBusinessContext()) {
      const actionSpec = this.lmActionService.getTargetAction({
        formSpec: this.formSpec,
        dataView
      });

      if (actionSpec !== null && actionSpec.type === AppConstants.ACTION_TYPE_CREATE) {
        return;
      }

      this.lmContextUtilService.buildContextMessages({
        busFormName: this.formSpec.busFormSpec.name,
        busClassName: this.formSpec.busClassSpec.name,
        widgetEventPrefix: AppConstants.RESOURCETYPE_FORM,
        dataObj: dataView,
        busContextMessages: this.formSpec.busContextMessages,
        busContextInvocations: this.formSpec.busContextInvocations
      })
        .subscribe((msgObj: any) => {
          if (msgObj.status === AppConstants.STATUS_COMPLETED) {

            if (contextMsgs) {
              msgObj = this.lmContextUtilService.mergeContextMessages({
                sourceMsgs: msgObj,
                addMsgs: contextMsgs
              });
            }

            if (this.isRouterOutletRootComponent || this.isActionForm || this.isBusinessTaskForm || this.isMingleInbox) {
              if (this.isActionForm || this.isBusinessTaskForm || this.isMingleInbox) {
                msgObj.doNotPersistMessage = true;
              }
              if (this.isActionForm) {
                msgObj.noDrillbackUrl = true;
              }
              this.lmContextUtilService.clearAll();
              this.lmContextUtilService.sendContextMessages(msgObj);
            } else {
              this.sendContextMessageEvent.emit(msgObj);
            }
          }
        });
    }
  }

  public onTitleChanged(event: any) {
    const titleChanged = event.detail;
    this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = titleChanged.newTitle;
  }

  onContentModified(event: any) {
    const dataView: LMDataView = this.getDataView();
    this.allowUpdate = this.isModified();

    if (dataView) {
      this.updateToolbarState(dataView, this.allowUpdate, true);
    }

    this.contentModified.emit(event);
  }

  // eslint-disable-next-line no-unused-vars
  onUpdateToolbarStateEvent(event: any) {
    const dataView: LMDataView = this.getDataView();
    this.allowUpdate = this.isModified();

    if (dataView) {
      this.updateToolbarState(dataView, this.allowUpdate, true);
    }
  }

  onSendContextMessageEvent(event: any) {
    this.sendBusinessContext(this.formViewData.dataView, event);
  }

  onSearchClicked(event: LMFilterEvent) {
    this.lmLoggerService.log([ this, this.instanceId, 'onSearchClicked()', event ]);
    this.searchButtonClicked.emit(event);
  }

  onClearSearchClicked(event: LMFilterEvent) {
    this.lmLoggerService.log([ this, this.instanceId, 'onClearSearchClicked()', event ]);
    this.clearSearchButtonClicked.emit(event);
  }

  onRunMatrixActionEvent(event: LMMatrixActionEvent) {
    this.runMatrixAction(event.actionTarget, event.actionSpec, event.dataView, event.callBack);
  }

  onFieldEvent(event: LMFieldEvent) {
    this.lmLoggerService.log([ this, this.instanceId, 'onFieldEvent()', this, event ]);

    if ('CheckControlEvent' === event.eventType) {
      const checkControlEvent = event as LMCheckControlEvent;
      const isChecked: boolean = checkControlEvent.isChecked;
      this.runCheckControlAction(checkControlEvent.layoutObject, isChecked);
    } else if ('ButtonEvent' === event.eventType) {
      const buttonEvent = event as LMButtonEvent;
      this.runFormButtonAction(buttonEvent.layoutObject);
    } else if ('TextLinkEvent' === event.eventType) {
      const linkEvent = event as LMTextEvent;

      if (linkEvent.layoutObject.hasHttpUrl || linkEvent.layoutObject.linkNavigation) {
        this.buildFormTextLinkNavigation(linkEvent.layoutObject);
      } else {
        this.runFormButtonAction(linkEvent.layoutObject);
      }
    } else if ('FireInitialValueRuleEvent' === event.eventType) {
      const evt: LMFieldValueChangedEvent = event as LMFieldValueChangedEvent;
      this.initialValueRuleCallQueue$.next(evt.bindId);
    } else if ('EvaluateConditionsEvent' === event.eventType) {
      // const evt: LMFieldValueChangedEvent = event as LMFieldValueChangedEvent;
      this.lmConditionUtilService.evaluateConditions.next(true);
    } else if ('MenuClickEvent' === event.eventType) {
      const menuEvent = event as LMMenuEvent;
      this.requestActionFromPageMenu(menuEvent);
    } else if ('InstanceCountChartEvent' === event.eventType) {
      const instanceCounterEvent = event as LMInstanceCountChartEvent;

      if (instanceCounterEvent.layoutObject.linkNavigation) {
        this.buildFormTextLinkNavigation(instanceCounterEvent.layoutObject);
      }
    } else if ('OpenCompactFormEvent' === event.eventType) {
      const evt: LMCompactFormEvent = event as LMCompactFormEvent;
      this.openCompactFormDialog(evt.fieldId, evt.title, evt.layout, evt.moreSpecFields, evt.originalCompactFormLayout, evt.displayOnly, evt.excludeOriginalField);
    } else if ('OpenSubFormEvent' === event.eventType) {
      const evt: LMSubFormEvent = event as LMSubFormEvent;
      this.openSubFormDialog(evt.fieldId, evt.title, evt.busFormSpec);
    } else if ('OpenLookupEvent' === event.eventType) {
      const evt: LMOpenLookupEvent = event as LMOpenLookupEvent;
      this.lookupFieldId = evt.fieldId;

    } else if ('OpenCubeSearchLookupEvent' === event.eventType) {
      this.cubeSearchOpenLookupEvent.emit(event);

    } else if ('DefineEvent' === event.eventType) {
      const evt: LMDefineEvent = event as LMDefineEvent;
      this.runDefineAction(this.getDataView(), evt.fieldId);
    } else if ('RelatedEvent' === event.eventType) {
      const relatedFormEvent = event as LMRelatedFormEvent;
      this.runDrillAction(relatedFormEvent.actionReference);
    } else if ('PreviewEvent' === event.eventType) {
      const previewEvent = event as LMPreviewEvent;
      this.previewQuery(previewEvent.query, previewEvent.busClass, previewEvent.fieldId);
    } else if ('QueryValidateEvent' === event.eventType) {
      const queryValidateEvent = event as LMQueryValidateEvent;
      this.validateLplQuery(queryValidateEvent.query, queryValidateEvent.busClass, queryValidateEvent.fieldId,  queryValidateEvent.isBusinessClassCompute, queryValidateEvent.computeType);
    } else if ('CubeRelationLPLValidationEvent' === event.eventType) {
      const cubeRelationLPLValidationEvent = event as LMCubeRelationLPLValidationEvent;
      this.validateCubeRelationLplQuery(cubeRelationLPLValidationEvent.query, cubeRelationLPLValidationEvent.busClass, cubeRelationLPLValidationEvent.fieldId);
    } else if ('TranslateEvent' === event.eventType) {
      const translateFormEvent = event as LMTranslateFormEvent;
      const navigationName = `${translateFormEvent.busClass}_${translateFormEvent.detName}_Translation`;
      this.runNavigation(navigationName, false, true);
    } else if ('InvalidLPLEvent' === event.eventType) {
      const invalidLPLEvent = event as LMInvalidLPLEvent;
      this.setHasValidationError(invalidLPLEvent.hasLPLValidationError);
    } else if ('FilterOperatorEvent' === event.eventType) {
      this.fieldEvent.emit(event);
    }
  }

  onContentLoadEvent(loadTime: number) {
    // eslint-disable-next-line no-unused-vars
    this.lmGlobalUtilService.updateClientStatsTelegraf(this.getComponentInfo(), loadTime).subscribe((response: any) => {});
  }

  private previewQuery(query: string, busClass: string, fieldId: string) {
    if (query.length > 0) {
      const formRequestUrlTemplate = urltemplate.parse(this.formUrlInfo.formRequestUrl);
      const formRequestUrl = formRequestUrlTemplate.expand({ resourceId: this.model.formResourceId });
      // Validate Observable
      this.lmFormRequestService.validateLplQuery(formRequestUrl, this.getDataView(), query, busClass)
        .subscribe(result => {
          if (result.lplStatus && result.lplStatus === 'LPL_VALID') {
            this.formModel.clearFieldError(fieldId);
            let lmPreviewComponentRef: LMPreviewOptionsDialogComponent;
            const buttons = [
              {
                text: Soho.Locale.translate('Cancel'),
                click: (e, modal) => {
                  modal.close(true);
                }
              },
              {
                text: Soho.Locale.translate('Ok'),
                click: (e, modal) => {
                  this.handleQueryPreviewAction(busClass, lmPreviewComponentRef.listName, query);
                  modal.close(true);
                },
                isDefault: true,
              }
            ];

            this.sohoModalDialogService
              .modal(LMPreviewOptionsDialogComponent, this.placeHolder, { fullsize: 'responsive' })
              .buttons(buttons)
              .title('Preview Options')
              .apply(dialogRef => {
                lmPreviewComponentRef = dialogRef;
                this.lmFormRequestService.getListViewsForBusClass(formRequestUrl, busClass).subscribe(listName => {
                  lmPreviewComponentRef.listNames = listName;
                });
              })
              .open();

          } else {
            this.formModel.setFieldError(fieldId, result.message);
          }
        });
    }
  }

  private validateLplQuery(query: string, busClass: string, fieldId: string, isBusinessClassCompute, computeType?: string) {
    this.formModel.clearFieldError(fieldId);
    this.hasLPLValidationError = false;
    if (query.length > 0) {
      const formRequestUrlTemplate = urltemplate.parse(this.formUrlInfo.formRequestUrl);
      const formRequestUrl = formRequestUrlTemplate.expand({ resourceId: this.model.formResourceId });
      // Validate Observable
      this.lmFormRequestService.validateLplQuery(formRequestUrl, this.getDataView(), query, busClass, isBusinessClassCompute, computeType)
        .subscribe(result => {
          this.lmLoggerService.log([ this, this.instanceId, 'LPL validation performed' ]);
          if (result.lplStatus && result.lplStatus !== 'LPL_VALID') {
            this.formModel.setFieldError(fieldId, Soho.Locale.translate('LplConditionError'), true);
            this.hasLPLValidationError = true;
          }
        });
    }
  }

  private validateCubeRelationLplQuery(query: string, busClass: string, fieldId: string) {
    this.formModel.clearFieldError(fieldId);
    this.hasLPLValidationError = false;
    if (query.length > 0) {
      const formRequestUrlTemplate = urltemplate.parse(this.formUrlInfo.formRequestUrl);
      const formRequestUrl = formRequestUrlTemplate.expand({ resourceId: this.model.formResourceId });
      // Validate Observable
      this.lmFormRequestService.validateCubeRelationLplQuery(formRequestUrl, query, busClass)
        .subscribe(result => {
          this.lmLoggerService.log([ this, this.instanceId, 'Cube Relation LPL validation performed' ]);
          if (result.status && result.status !== 'LPL_VALID') {
            this.formModel.setFieldError(fieldId, result.error, true);
            this.hasLPLValidationError = true;
          }
        });
    }
  }

  private setHasValidationError(hasLPLValidationError: boolean) {
    this.hasLPLValidationError = hasLPLValidationError;
  }

  private handleQueryPreviewAction(busClass: string, listName: string, query: string) {
    const formRequestUrlTemplate = urltemplate.parse(this.formUrlInfo.previewActionUrl);
    const hasLongLplFilter = query.length > 500;
    let formRequestUrl = formRequestUrlTemplate.expand({ resourceId: busClass, listName, filter: query });

    if (hasLongLplFilter) {
      // add the filter query to local storage, and retrieve it later on the list
      const filterId = this.lmListFilterPersistenceService.getUniqueFilterId(`${busClass}.${listName}`);
      this.lmListFilterPersistenceService.setFilterItem(filterId, query);

      //remove the long filter query, use the filter id generated instead.
      formRequestUrl = this.lmUrlUtilService.removeParam(formRequestUrl, 'filter');
      formRequestUrl = this.lmUrlUtilService.addParamToUrl(formRequestUrl, 'filterId', filterId);

    }


    this.lmGlobalUtilService.navigate(formRequestUrl, null, 'external');
  }

  onStepPanelEvent(event: LMStepPanelEvent): void {

    const dataView = this.model.getData();

    if (AppConstants.FORM_PANEL_TRANSACTION_COMMIT_TYPE === event.panelTransaction) {
      this.executeSave(AppConstants.STANDARD_SAVE, dataView, event.transactionObserver, true);
    } else if (AppConstants.FORM_PANEL_TRANSACTION_VALIDATION_TYPE === event.panelTransaction) {
      const actionName = dataView.action;
      const actionSpec = this.lmActionService.getActionByName(this.formSpec.busClassSpec.actions, actionName);
      this.runValidateFormPanel(actionSpec, dataView, event.panelId, event.transactionObserver);
    }
  }

  onPanelTransactionEvent(event: LMPanelTransactionEvent): void {
    this.lmLoggerService.time({ id: 'LMForm.onPanelTransactionEvent() ' + this.instanceId });

    // don't refresh and lose unsaved data!
    if (this.model.isDirty) {
      if (event.callBack) {
        event.callBack.next(true);
        event.callBack.complete();
      }
      return;
    }

    const refreshRecord = this.lmFormPagingService.refreshRecord(this.getDataView(), this.formUrlInfo.navigationContext).subscribe((reloadDataView: LMDataView) => {
      if (reloadDataView.status === AppConstants.STATUS_SYSTEM_ERROR){
        const errorResponse = reloadDataView as LMSystemException;
        this.lmErrorUtilService.handleError(errorResponse.message, errorResponse.details, errorResponse.status);
        this.lmLoggerService.error([ 'lmform onPanelTransactionEvent()', errorResponse ]);
      } else {
        if (reloadDataView.serverLog) {
          this.lmLoggerService.serverLog(reloadDataView.serverLog);
        }
        this._initDataView = reloadDataView;
        this.formViewData.dataView = this._initDataView;
        this.model.setData(this._initDataView, { notifyListeners: true, source: event });
        this.updateToolbarState(this._initDataView, this.allowUpdate, true);
      }

      // TODO: Refactor step to NOT use a callback
      // let the step content know you are done
      if (event.callBack) {
        event.callBack.next(true);
        event.callBack.complete();
      }
    });

    this.subscriptionArray.push(refreshRecord);
    this.lmLoggerService.time({ id: 'LMForm.onPanelTransactionEvent() ' + this.instanceId });
  }

  private runValidateFormPanel(actionSpec: LMActionSpec, dataView: LMDataView, panelName: string, callBack?: Observer<boolean>): void {
    const formContext: LMFormContext = {
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      formModel: this.model,
      placeholder: this.placeHolder
    };

    if (this.validateConfigRequiredFields(this.configRequiredFields)) {
      this.lmFormTransactionService.runValidateFormPanel(formContext, actionSpec, dataView, panelName).subscribe(
        (transactionState: LMTransactionState) => {
          this.handleTransactionStatus(transactionState.getTransactionResult());
          if (transactionState.isSuccess()) {
            this.model.updateData(transactionState.getTransactionResult().dataView, { notifyListeners: true });
          }
          if (callBack) {
            callBack.next(transactionState.isSuccess());
            callBack.complete();
          }
        });

    } else {
      if (callBack) {
        callBack.next(false);
        callBack.complete();
      }
    }
  }

  onBeforeFormToolbarMoreMenuOpen = (response: SohoPopupMenuResponseFunction, options: any) => {
    let buttons = [];
    if (this.isRouterOutletRootComponent && !this.hideTitleBar) {
      buttons = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.flexMoreButtons;
      if (options.isSubmenu) {
        // if a submenu, then need all the buttons for flex toolbar. This is because a menu button could get overflowed
        // and since it was in the buttonset, it wasn't in the flexMoreButtons
        buttons = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.flexButtons;
      }
    } else {
      buttons = this.lmToolbarComponent.flexMoreButtons;
      if (options.isSubmenu) {
        // if a submenu, then need all the buttons for flex toolbar. This is because a menu button could get overflowed
        // and since it was in the buttonset, it wasn't in the flexMoreButtons
        buttons = this.lmToolbarComponent.flexButtons;
      }
    }

    let showDrillAround = true;
    if (!!this.lmContextService.getContext().disallowNavigations || this.model.isCreateAction) {
      showDrillAround = false;
    }

    if (options.hasOwnProperty('contextElement')) {
      const drillPointsParams: DrillPointsParams = { dataView: this.getDataView() };

      // eslint-disable-next-line @typescript-eslint/ban-types
      // let relatedActionsFunction: Function;
      let relatedActionsFunction: (response: AjaxBeforeOpenResponseFunction, options: any) => void;
      if (this.lmToolbarComponent) {
        relatedActionsFunction = this.lmToolbarComponent.onBeforeRelatedActionsOpen;
      } else if (this.lmBannerHeaderCompRef.instance.lmToolbarComponent) {
        relatedActionsFunction = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.onBeforeRelatedActionsOpen;
      }
      this.lmFormToolbarService.buildMoreButtonMenu(this.formSpec, response, options, buttons, { drillParams: drillPointsParams,
        showDrillAround, isContextMenu: false }, relatedActionsFunction);
    } else {
      const responseString = this.lmFormToolbarService.buildFirstLevelMoreMenu(this.formSpec, buttons, showDrillAround);
      response(responseString);
    }
  };

  public get formResource(): FormResource {
    return this.formResourceImpl;
  }

  public set formResource(formResource: FormResource) {
    this.formResourceImpl = formResource;
  }

  public get fromResource(): KeyedResource {
    return this.fromResourceImpl;
  }

  public set fromResource(fromResource: KeyedResource) {
    this.fromResourceImpl = fromResource;
  }

  // moved from template
  public get showToolbarOnForm(): boolean {
    // show toolbar on mingle inbox (action forms and process flows)
    // or when in root component and context has hide title toolbar true
    return this.lmContextService.inMingleInbox() || (this.isRouterOutletRootComponent && this.hideTitleBar) || (this.formSpec && this.formSpec.busFormSpec.implementsCartView);
  }

  /***********************************************
   * PUBLIC METHODS
   ***********************************************/
  public load(): Promise<LoadResponse<LMDataView>> {
    this.lmLoggerService.trace([ this, this.instanceId, 'load()' ]);

    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      if (this.formSpec.busFormSpec.panelNavigation) {
        this._loadStepRecord();
      } else {
        this._loadStandardRecord();
      }
    });
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    this.lmLoggerService.trace([ this, this.instanceId, 'onToolbarButtonEvent()', toolbarButtonEvent.actionReference ]);

    if (toolbarButtonEvent.actionReference === undefined || toolbarButtonEvent.actionReference === null) {
      return;
    }

    if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_ACTION) {
      this.runAction(this.formSpec.busClassSpec.actions[toolbarButtonEvent.actionReference.index]); // Call out Actions.
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_STANDARD_ACTION) {
      this.runStandardAction(toolbarButtonEvent.actionReference);
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_PROCESSFLOW) {
      this.runProcessFlowAction(toolbarButtonEvent.actionReference.id);
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_NAVIGATION) {
      this.runNavigation(toolbarButtonEvent.actionReference.navigation, toolbarButtonEvent.actionReference.showAsPdf);
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_HTTPURL) {
      this.runUILinkHttpUrl(toolbarButtonEvent.actionReference.httpURL, this.getDataView());
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_FORMINVOKE) {
      const formUrl = this.lmUrlUtilService.buildUrl({ resource: this.formResource });
      this.lmNavigationService.runFormInvoke(formUrl, toolbarButtonEvent.actionReference.name, this.model.getData());
    } else if (toolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_RELATED) {
      // if (toolbarButtonEvent.actionReference.relActionUrl) {
      if (toolbarButtonEvent.actionReference.isDrillAround) {
        this.runDrillAction(toolbarButtonEvent.actionReference);
      } else {
        this.runRelatedAction(toolbarButtonEvent.actionReference.resourceId, toolbarButtonEvent.actionSpec);
      }
    }
  }

  public onSpecialActionToolbarButtonEvent(specialActionToolbarButtonEvent: LMSpecialActionToolbarButtonEvent) {
    this.lmLoggerService.trace([ this, this.instanceId, 'onToolbarButtonEvent()', specialActionToolbarButtonEvent.actionReference ]);

    if (specialActionToolbarButtonEvent.actionReference === undefined || specialActionToolbarButtonEvent.actionReference === null) {
      return;
    }

    this.runningSpecialActionList = specialActionToolbarButtonEvent.list;

    if (specialActionToolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_ACTION) {
      this.runAction(this.formSpec.busClassSpec.actions[specialActionToolbarButtonEvent.actionReference.index]); // Call out Actions.

    } else if (specialActionToolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_STANDARD_ACTION) {
      this.runStandardAction(specialActionToolbarButtonEvent.actionReference);

    } else if (specialActionToolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_PROCESSFLOW) {
      this.runProcessFlowAction(specialActionToolbarButtonEvent.actionReference.id);

    } else if (specialActionToolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_NAVIGATION) {
      this.runNavigation(specialActionToolbarButtonEvent.actionReference.navigation, specialActionToolbarButtonEvent.actionReference.showAsPdf);

    } else if (specialActionToolbarButtonEvent.actionReference.type === AppConstants.BUTTON_TYPE_RELATED) {
      // if (specialActionToolbarButtonEvent.actionReference.relActionUrl) {
      if (specialActionToolbarButtonEvent.actionReference.isDrillAround) {
        this.runDrillAction(specialActionToolbarButtonEvent.actionReference);
      } else {
        this.runRelatedAction(specialActionToolbarButtonEvent.actionReference.resourceId, specialActionToolbarButtonEvent.actionSpec);
      }
    }
  }

  public runCheckControlAction(checkControl: LMCheckControl, isChecked) {
    const checkControlActions: Array<LMCheckControlAction> = isChecked ? checkControl.checkActions : checkControl.uncheckActions;

    if (checkControlActions === null || checkControlActions.length === 0) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: No ' + (isChecked ? 'Check' : 'Uncheck') + ' actions defined.' ]);
      return;
    }

    const validAction: LMActionSpec = this.getFirstValidCheckControlAction(checkControlActions);

    if (validAction === null) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: No valid ' + (isChecked ? 'Check' : 'Uncheck') + ' action defined.' ]);
      return;
    }

    if (AppConstants.ACTION_TYPE_FUNCTION !== validAction.type) {
      this.lmLoggerService.warn([ this, this.instanceId, 'runCheckControlAction: Only Instance Actions are supported for Check Controls. Action: ' + validAction.name ]);
      return;
    }

    // TODO when form state is updated this field is disabled if there is no valid action for the state it is in
    // TODO what happens if the action fails or has a confirmation message
    // TODO YES should i save the form before running this action

    this.runInstanceAction(validAction);
  }

  private getFirstValidCheckControlAction(checkControlActions: Array<LMCheckControlAction>): LMActionSpec {
    for (const checkControlAction of checkControlActions) {
      if (checkControlAction.condition) {
        const conditions: LMCondition[] = [];
        conditions[0] = checkControlAction.condition;

        if (this.lmConditionUtilService.isValid(conditions, this.model)) {
          return checkControlAction.actionSpec;
        }
      } else {
        return checkControlAction.actionSpec;
      }
    }

    return null;
  }

  public buildFormTextLinkNavigation(link: LMButtonLayout) {
    if (link.httpUrl) {
      const option: string = (link.openExternal) ? 'external' : '';
      let url: string;
      const dataView: LMDataView = this.getDataView();
      if (dataView && dataView.buttonLinks && dataView.buttonLinks[link.fieldId]) {
        url = dataView.buttonLinks[link.fieldId];
      } else {
        url = this.lmFormatUtilService.formatMessageRule(link.httpUrl, dataView);
      }

      if (url) {
        // When getting a http url/linkback that returns a navigation, we need to handle
        // by calling runNavigation instead of navigate. This will prevent the navigation
        // url from replacing the current lmclient route.
        // see LMCLIENT-35609.
        let resource: KeyedResource;
        try {
          //getRouteResource will throw an error if the url cannot be parsed.
          resource = this.lmUrlUtilService.getRouteResource(url);
        } catch (e) {
          //noop
        }

        if (resource?.resourceType === 'navigation') {
          this.lmNavigationService.runNavigation(url, undefined, { openNewTab: link.openExternal });
        } else {
          this.lmGlobalUtilService.navigate(url, null, option);
        }

      }
    } else if (link.linkNavigation) {
      this.runNavigation(link.linkNavigation, link.showAsPdf);
    } else if (link.registerLink) {
      this.lmGlobalUtilService.navigateByUrl(link.registerLink, null);
    } else if (link.signInLink) {
      this.lmGlobalUtilService.navigate(link.signInLink);
    } else if (link.signOutLink) {
      this.lmGlobalUtilService.navigate(link.signOutLink);
    }
  }

  // TODO this seems to duplicate runAction
  public requestActionFromPageMenu(menuEvent) {
    this.lmSpecService.getRedirectUrl(menuEvent.link).subscribe((response: LMPageMenuReqActionResponse) => {
      if (!response.dialogUrl) {
        this.lmGlobalUtilService.navigateByUrl(response.redirectUrl);
        return;
      }

      if (this.lmContextService.hasAsOfDateInPast()) {
        this.lmGlobalUtilService.displayAsOfDateInPastMessage();
        return;
      }
      this.lmBusyIndicatorService.showBusyIndicator();

      const resourceId = response.resourceId;
      const actionName = response.action;
      this.lmSpecService.getFormSpecFromDialogActionUrl(response.dialogUrl)
        .subscribe((formUrlResponse: LMFormSpecResponse) => {
          let index = 0;

          const formUrlInfo = formUrlResponse.formUrlInfo;
          const formSpec = formUrlResponse.formSpec;

          formSpec.busClassSpec.actions.forEach((data) => {
            if (data.name === actionName) {
              index = data.index;
            }
          });

          const actionSpec: LMActionSpec = formSpec.busClassSpec.actions[index];
          const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
          const url = urlCompiledTemplate.expand({ resourceId, actionName: actionSpec.name });
          this.lmActionFormDialogService.getActionFormDialogDataView(url).pipe(first()).subscribe((responseDV: any) => {

            const formDataView: LMDataView = responseDV;
            if (formDataView.status !== AppConstants.STATUS_COMPLETED) {
              this.lmLoggerService.error(responseDV);
              this.lmErrorUtilService.handleError(responseDV.message, responseDV.details, responseDV.status, responseDV.statusText);
              return;
            }

            this.lmActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, actionSpec, formDataView)
              .subscribe((actionFormDialogResult: LMActionFormDialogResult) => {
                if (actionFormDialogResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
                  // The view exception and errors will be prompted before the dialog closes.
                  // So just print the success message here after the dialog closes
                  const transactionState: LMTransactionState = actionFormDialogResult.transactionStateResult;
                  const actionResult: LMActionResult = actionFormDialogResult.transactionStateResult.getTransactionResult();

                  this.lmGlobalUtilService.displayToastMessage(actionSpec.label, actionResult.message, AppConstants.TRA_ACTION_COMPLETED);

                  if (transactionState.isSuccess()) {
                    if (actionResult.isCompletionNavigation && actionResult.redirectUrl) {
                      this.lmNavigationService.runNavigation(actionResult.redirectUrl);
                    }
                  }
                }
              });
          });
        });
    });
  }

  public runFormButtonAction(formButton: LMButtonLayout) {
    let url: string;
    switch (formButton.type) {
      case AppConstants.BUTTON_TYPE_ACTION:
        this.runAction(formButton.actionSpec);
        break;

      case AppConstants.BUTTON_TYPE_NAVIGATION:
        this.runNavigation(formButton.navigation, formButton.showAsPdf);
        break;

      case AppConstants.BUTTON_TYPE_LIST_REFERENCE:
        const newListResource = new ListResource(
          {
            resourceId: formButton.resourceId
          });

        const args = { resourceId: formButton.relationResourceId, dataView: this.model.getData() };
        const contextResource = new RelationResource(args, formButton.relationResourceId);

        const listUrl = this.lmUrlUtilService.buildUrl({ resource: newListResource, contextResource });

        if (listUrl) {
          this.lmGlobalUtilService.navigateByUrl(listUrl);
        }
        break;

      case AppConstants.BUTTON_TYPE_RELATED:
        this.runButtonRelatedAction(formButton.relActionUrl, formButton.name);
        break;

      case AppConstants.BUTTON_TYPE_FORMINVOKE:
        // just need form url and csk params. no other params are required for a form invoke.
        const formUrl = this.lmUrlUtilService.buildUrl({ resource: this.formResource });
        this.lmNavigationService.runFormInvoke(formUrl, formButton.formInvokeName, this.model.getData());
        break;

      case AppConstants.BUTTON_TYPE_HTTPURL:
        const dataView: LMDataView = this.getDataView();
        this.runHttpUrl(formButton, dataView);
        break;

      case AppConstants.BUTTON_TYPE_SUBFORM:
        // TODO:
        break;

      case AppConstants.BUTTON_TYPE_VIEWDOCUMENT:
      case AppConstants.BUTTON_TYPE_SHOWEDITOR:
        this.openDocumentResource(formButton);
        break;
      case AppConstants.BUTTON_TYPE_EXPORTDOCUMENT:
        // TODO:
        break;

      case AppConstants.BUTTON_TYPE_FORMBUTTON:
        if (formButton.dataViewFieldButton) {
          this.openDataViewFieldButtonForm(formButton);
        } else if (formButton.isStandardAction) {
          // Only implementing save standard action for now
          switch(formButton.standardActionName) {
            case AppConstants.STANDARD_SAVE:
              this.runStandardAction({ id: formButton.standardActionName, type: 'standard' });
              break;
            default:
              break;
          }
        }
        break;
      case AppConstants.BUTTON_TYPE_REGISTRATION:
        // TODO where is the URL gotten from for this case?
        this.lmGlobalUtilService.navigateByUrl(url);
        break;
      case AppConstants.BUTTON_TYPE_SIGNIN:
        this.lmGlobalUtilService.navigate(formButton.signInLink);
        break;
      case AppConstants.BUTTON_TYPE_SIGNOUT:
        this.lmGlobalUtilService.navigate(formButton.signOutLink);
        break;
    }
  }

  private runHttpUrl(formButton: LMButtonLayout, dataView: LMDataView): void {
    if (!formButton) {
      return;
    }

    const openExternal = !!formButton.openExternal;
    let url: string;

    if (formButton.isLazyUrlRetrieval && formButton.httpUrl?.variables) {
      const compiledFormRequestUrl = urltemplate.parse(this.formUrlInfo.formRequestUrl);
      const requestUrl = compiledFormRequestUrl.expand({ resourceId: this.model.formResourceId });
      const reqFields = Array.from(formButton.httpUrl?.variables, field => field.fieldId );

      this.lmFormRequestService.getFieldValues(requestUrl, reqFields).pipe(
        first(),
        catchError( error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Internal Server Error');
        })
      ).subscribe( (response: LMFieldValuesResponse) => {
        if (response.status === 'Completed') {
          const fields: LMDataView = { fields: response.fields };
          url = this.lmFormatUtilService.formatMessageRule( formButton.httpUrl, fields );
          this.lmNavigationService.postProcessHttpUrl(url, openExternal);
        } else if (response.status === 'Exception') {
          this.lmErrorUtilService.handleError(response?.message, response?.details, response.status);
        }
      });
    } else if (dataView?.buttonLinks?.[formButton.fieldId]) {
      url = dataView.buttonLinks[formButton.fieldId];
      this.lmNavigationService.postProcessHttpUrl(url, openExternal);
    } else {
      url = this.lmFormatUtilService.formatMessageRule(formButton.httpUrl, dataView);
      this.lmNavigationService.postProcessHttpUrl(url, openExternal);
    }
  }

  private runStandardAction(actionReference: LMBusActionReference) {
    const dataView: LMDataView = this.getDataView();
    const formSpec: LMFormSpec = this.formSpec;

    switch (actionReference.id) {
      case AppConstants.STANDARD_TOOLBAR_MATRIXSHOWDETAIL:
        this.showMatrixDetail = true;
        this.updateToolbarState(dataView, this.allowUpdate, false);
        this.runMatrixToggleDetail();
        break;
      case AppConstants.STANDARD_TOOLBAR_MATRIXHIDEDETAIL:
        this.showMatrixDetail = false;
        this.updateToolbarState(dataView, this.allowUpdate, false);
        this.runMatrixToggleDetail();
        break;
      case AppConstants.STANDARD_TOOLBAR_CREATE:
        const createActionSpec: LMActionSpec = this.lmActionService.getDefaultCreateAction(formSpec.busClassSpec.actions, dataView.actionIndexes);
        this.runCreateAction(createActionSpec);
        break;

      case AppConstants.STANDARD_TOOLBAR_UPDATE:
      case AppConstants.STANDARD_TOOLBAR_OPEN:
        const updateActionSpec: LMActionSpec = this.lmActionService.getDefaultUpdateAction(formSpec.busClassSpec.actions, dataView.actionIndexes);
        this.runUpdateAction(updateActionSpec);
        break;

      case AppConstants.STANDARD_TOOLBAR_DELETE:
        const deleteActionSpec: LMActionSpec = this.lmActionService.getFormDeleteAction(formSpec.busClassSpec.actions, dataView);
        this.runDeleteAction(deleteActionSpec);
        break;

      case AppConstants.STANDARD_TOOLBAR_PREVRECORD:
        this.getPreviousRecord(dataView);
        break;
      case AppConstants.STANDARD_TOOLBAR_NEXTRECORD:
        this.getNextRecord(dataView);
        break;
      case AppConstants.STANDARD_TOOLBAR_REFRESH:
        this._runRefresh();
        break;

      case AppConstants.STANDARD_TOOLBAR_SCHEDULE:
        this.runSchedule(dataView);
        break;

      case AppConstants.STANDARD_SAVE:
      case AppConstants.STANDARD_TOOLBAR_SAVEASDRAFT:
        if (this.scheduleView) {
          dataView.scheduleView = this.scheduleView;
        }
        this.runSave(actionReference.id, dataView);
        break;

      case AppConstants.STANDARD_TOOLBAR_SAVENEW:
        this.runSave(actionReference.id, dataView);
        break;

      case AppConstants.STANDARD_TOOLBAR_SAVECLOSE:
        this.runSave(actionReference.id, dataView);
        break;

      case AppConstants.STANDARD_TOOLBAR_PRINTTOFILE:
      case AppConstants.STANDARD_TOOLBAR_EXPORTPDF:
        this.runPdfAction(actionReference);
        break;

      case AppConstants.STANDARD_TOOLBAR_EXPORTCSV:
        this.runCsvAction(actionReference);
        break;

      // TODO: TECHNICAL DEBT: use localization here
      case AppConstants.STANDARD_TOOLBAR_SEARCH:
        break;

      case AppConstants.STANDARD_TOOLBAR_VIEWACTION:
        // landmark.dialog.showMessageDialog("", "Standard View action is not yet implemented");
        break;

      case AppConstants.STANDARD_TOOLBAR_CHARTMENU_BUTTON:
        // landmark.dialog.showMessageDialog("", "Chart Toggle is not yet implemented");
        break;

      case AppConstants.STANDARD_TOOLBAR_HELPERLIST:
        // landmark.dialog.showMessageDialog("", "Helper List is not yet implemented");
        break;

        //     case AppConstants.STANDARD_TOOLBAR_CREATEMENU_BUTTON:
        //     break;
        //     case AppConstants.STANDARD_TOOLBAR_ACTIONSMENU_BUTTON:
        //     break;
        //     case AppConstants.STANDARD_TOOLBAR_OPTIONSMENU_BUTTON:
        //     break;

      case AppConstants.STANDARD_TOOLBAR_VIEWAUDIT:
      case AppConstants.STANDARD_TOOLBAR_VIEWFULLAUDIT:
        this.runAuditLogAction(dataView,
          actionReference.id === AppConstants.STANDARD_TOOLBAR_VIEWAUDIT ? 'viewAudit' : 'viewFullAudit');
        break;
      case AppConstants.STANDARD_TOOLBAR_PFCOMPARE:
        this.runCompareAction();
        break;
      default:
        break;
    }
  }

  private getPdfType(busFormSpec: LMBusFormSpec): string {
    // TODO: Switch to its constant once available
    return (busFormSpec.formType === LMFormType.COMPOSITE) ?
      AppConstants.COMPOSITE_FORM_PDF :
      AppConstants.REGULAR_FORM_PDF;
  }

  private runPdfAction(actionReference: LMBusActionReference) {
    const settings = <LMPrintPdfInfo>{
      resource: this.formResource,
      fromResource: this.fromResourceImpl,
      actionReference,
      name: this.formTitle,
      pdfType: this.getPdfType(this.formSpec.busFormSpec),
      dataView: this.getDataView(),
      scheduleActionAllowed: this.formSpec.scheduleActionAllowed,
      selectedTabIndex: this.formState.selectedPanelIndex,
      fontOffset: this.formSpec.busFormSpec.fontOffset,
      orientation: this.formSpec.busFormSpec.orientation,
    };

    this.lmPrintDialogService.openPdfDialog(settings);
  }

  private runCsvAction(actionReference: LMBusActionReference) {
    const settings = <LMPrintCsvInfo>{
      modalPlaceholder: this.placeHolder,
      resource: this.formResource,
      fromResource: this.fromResource,
      actionReference,
      dataView: this._initDataView,
      name: this.formTitle,
      scheduleActionAllowed: this.formSpec.scheduleActionAllowed,
    };

    this.lmPrintDialogService.openCsvDialog(settings);
  }

  public runAuditLogAction(dataView: LMDataView, auditType: string): void {
    const auditActionRedirectUrlTemplate = urltemplate.parse(this.formUrlInfo.viewAuditLogRedirectUrl);
    const auditActionRedirectUrl = auditActionRedirectUrlTemplate.expand({
      resourceId: dataView.resourceId,
      actionName: auditType,
      contextResourceId: this.getDataView().contextProperties.resourceId
    });

    this.lmGlobalUtilService.navigateByUrl(auditActionRedirectUrl);
  }

  public runRefresh(callBack: Observer<boolean>) {
    this.refreshData(callBack);
  }

  private refreshData(callBack?: Observer<boolean>): void {
    this.lmLoggerService.time({ id: 'LMForm.refreshData() ' + this.instanceId });

    const navigationContext = this.formUrlInfo.navigationContext;
    const refreshRecord = this.lmFormPagingService.refreshRecord(this.getDataView(), navigationContext)
      .subscribe((reloadDataView: LMDataView) => {
        if (reloadDataView.serverLog) {
          this.lmLoggerService.serverLog(reloadDataView.serverLog);
        }

        // if modelSourceEvent is null then we must be doing a refresh
        if (this.modelSourceEvent == null) {
          this.modelSourceEvent = { type: 'refresh' };
        }

        this.initDataView = reloadDataView;

        if (callBack) {
          callBack.next(true);
          callBack.complete();
        } else {
          this.formContentComponent.runRefresh();
        }

        this.lmLoggerService.timeEnd('LMForm.refreshData() ' + this.instanceId);
      });

    this.subscriptionArray.push(refreshRecord);
  }

  private getPreviousRecord(dataView: LMDataView) {
    const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg') };                                       // needs translation
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._getPreviousRecord(dataView);
      }
    });
  }

  private _getPreviousRecord(dataView: LMDataView) {
    this.lmLoggerService.time({ id: 'LMForm.getPreviousRecord() ' + this.instanceId });
    const currentDataView = dataView;

    this.lmFormPagingService.previousRecord(dataView).pipe(first()).subscribe((previousDataView: LMDataView) => {
      if (previousDataView.status === AppConstants.STATUS_SYSTEM_ERROR) {
        const errorResponse: LMSystemException = previousDataView;
        currentDataView.pagingInfo.hasPrevious = false;
        this.initDataView = currentDataView;
        const title = Soho.Locale.translate('PreviousRecordActionFailed');
        // todo not sure what there is to translate here. shouldn't we just be displaying the errorResponse message as is.
        //  - Phillip 03/15/2021
        const message = Soho.Locale.translate(errorResponse.message);
        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_FAILED);
      } else {
        this.handleFormPagingResponse(previousDataView);
      }
      this.lmLoggerService.timeEnd('LMForm.getPreviousRecord() ' + this.instanceId);
    });
  }

  private getNextRecord(dataView: LMDataView): void {
    const info: LMDialogInfo = { message: Soho.Locale.translate('UnsavedChangesContinuingMsg') };                                       // needs translation
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._getNextRecord(dataView);
      }
    });
  }

  private _getNextRecord(dataView: LMDataView): void {
    this.lmLoggerService.time({ id: 'LMForm.getNextRecord() ' + this.instanceId });
    const currentDataView = dataView;

    this.lmFormPagingService.nextRecord(dataView).pipe(first()).subscribe((nextDataView: LMDataView) => {
      if (nextDataView.status === AppConstants.STATUS_SYSTEM_ERROR) {
        const errorResponse: LMSystemException = nextDataView;
        currentDataView.pagingInfo.hasNext = false;
        this.initDataView = currentDataView;
        const title = Soho.Locale.translate('NextRecordActionFailed');
        const message = Soho.Locale.translate(errorResponse.message);
        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_FAILED);
      } else {
        this.handleFormPagingResponse(nextDataView);
      }
      this.lmLoggerService.timeEnd('LMForm.getNextRecord() ' + this.instanceId);
    });
  }

  private handleFormPagingResponse(dataView: LMDataView): void {
    if (dataView.serverLog) {
      this.lmLoggerService.serverLog(dataView.serverLog);
    }

    //---------------------------------------------------------------------
    // save state for current form dataview
    //---------------------------------------------------------------------
    this.saveComponentState();

    //---------------------------------------------------------------------
    // set the initDataView to cause the form data to change.
    // replace the current url using the new form url
    //---------------------------------------------------------------------
    this.modelSourceEvent = { type: 'paging' };
    this.initDataView = dataView;
    this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(dataView.formUrl));

    //---------------------------------------------------------------------
    // reset formUrlInfo.resource using the new url
    //---------------------------------------------------------------------
    this.formUrlInfo.resource = this.lmUrlUtilService.getRouteResource();

    //---------------------------------------------------------------------
    // reset the state key so when it's called later it will rebuild
    // using the current formUrlInfo.resource.resourceId
    //---------------------------------------------------------------------
    this.formStateKeyParams = null;
  }

  private runAction(actionSpec: LMActionSpec) {
    // Call out Actions.
    switch (actionSpec.type) {
      case AppConstants.ACTION_TYPE_CREATE:
      case AppConstants.ACTION_TYPE_IMPORT:
        this.runCreateAction(actionSpec);
        break;

      case AppConstants.ACTION_TYPE_UPDATE:
        this.runUpdateAction(actionSpec);
        break;

      case AppConstants.ACTION_TYPE_DELETE:
        this.runDeleteAction(actionSpec);
        break;

      case AppConstants.ACTION_TYPE_FUNCTION:
        this.runInstanceAction(actionSpec);
        break;

      case AppConstants.ACTION_TYPE_SET:
        this.runSetAction(actionSpec);
        break;

      case AppConstants.STANDARD_TOOLBAR_VIEWAUDIT:
      case AppConstants.STANDARD_TOOLBAR_VIEWFULLAUDIT:
        // TODO:
        break;

      default:
        this.lmLoggerService.warn([ this, this.instanceId, 'runAction: Invalid action type - ' + actionSpec.type ]);
    }
  }

  // this is called from independent form panel
  public runSaveAction(actionReferenceId: string, callBack: Observer<boolean>, dontShowToast?: boolean) {
    const dataView: LMDataView = this.getDataView();
    this.runSave(AppConstants.STANDARD_SAVE, dataView, callBack, dontShowToast);
  }

  // Do NOT check if dirty because we do not want to force
  // user to change a value to run the action
  public runActionSpec(targetAction: string, callBack: Observer<boolean>, skipToast?: boolean) {
    this.waitForFormToBeReady().subscribe(() => {
      if (this.validateConfigRequiredFields(this.configRequiredFields)) {
        const formContext: LMFormContext = {
          formUrlInfo: this.formUrlInfo,
          formSpec: this.formSpec,
          formModel: this.model,
          placeholder: this.placeHolder
        };
        const dataView = this.getDataView(); // initial value rules mayhave updated the dataview
        const actionSpec = this.lmFormActionUtilService.getTargetAction(this.formSpec, dataView, targetAction);
        this.lmFormTransactionService.runIndependentAction(formContext, actionSpec, dataView).subscribe(
          transactionState => {
            if (transactionState.isError) {
              this.lmErrorUtilService.handleError(
                transactionState.response.message,
                transactionState.response.details,
                transactionState.response.status,
                transactionState.response.message);
            } else if (transactionState.isCanceled) {
              // TODO DPB
            } else {
              if (transactionState.postRegUrl) {
                // const postRegUrl: string = transactionState.postRegUrl;
                window.location.href = transactionState.postRegUrl;  // This should never happen right!
              } else {
                const result: LMActionResult = transactionState.getTransactionResult();

                if (result) {
                  this.handleTransactionStatus(result);
                  if (transactionState.isSuccess()) {
                    if (result.redirectUrl) {
                      setTimeout(() => {
                        result.redirectUrl = this.lmUrlUtilService.toRelativeUrl(result.redirectUrl, true, true);
                        this.location.replaceState(result.redirectUrl);
                      }, 1);
                    } else {
                      if (this.runningSpecialActionList) {
                        this.model.setData(result.dataView, { source: { type: 'transaction' } });
                        this.runningSpecialActionList.refresh(null);  // TODO: dpb shouldnt this wait!
                        this.runningSpecialActionList = null;
                      } else {
                        this.initDataView = result.dataView;
                      }
                    }

                    if (transactionState.isSuccess() && !skipToast) {
                      const title = result.actionSpec.label;
                      const message = result.message || Soho.Locale.translate('ActionSuccessful');
                      this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                    }
                  }
                }
              }
            }

            if (callBack) {
              callBack.next(transactionState.isSuccess());
              callBack.complete();
            }

            this.lmBusyIndicatorService.hideBusyIndicator();
          });
      } else {
        this.lmBusyIndicatorService.hideBusyIndicator();
        if (callBack) {
          callBack.next(false);
          callBack.complete();
        }
      }
    });
  }

  private _runRefresh() {
    if (this.checkSaveRequired()) {
      const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg') };
      this.handleUnsavedChanges(info).subscribe(response => {
        if (response) {
          this.refreshData();
        }
      });
    } else {
      this.refreshData();
    }
  }

  private runSchedule(dataView: LMDataView) {
    const actionSpec = this.lmActionService.getTargetAction({
      formSpec: this.formSpec,
      dataView
    });
    this.lmScheduleDialogService.openScheduleDialog(dataView.busClassName, actionSpec.name).subscribe((scheduleView: LMDataView) => {
      this.scheduleView = scheduleView;
    });
  }

  private runSave(actionReferenceId: string, dataView: LMDataView, callBack?: Observer<boolean>, dontShowToast?: boolean) {

    if (this.formContentComponent && !this.hasLPLValidationError /*&& !this.formModel.hasError*/) {
      if (_.isEmpty(this.model.multiPartFields)) {
        this.lmBusyIndicatorService.showBusyIndicator();
      }

      this.formContentComponent.runSaveAction().subscribe(
        (continueOn: boolean) => {
          if (continueOn) {
            // no problem saving panels that were dirty
            if (this.model.isDirty || this.model.isCreateAction) {
              this.executeSave(actionReferenceId, dataView, callBack, dontShowToast);
            } else {
              // LMCLIENT-24825 [Save and Close] button is not closing the Form
              // Execute save closes the form, however, there are times when only the
              // form panels were dirty.
              if (actionReferenceId === AppConstants.STANDARD_TOOLBAR_SAVECLOSE) {
                this.location.back();
                return;
              }
              // May have saved a related list on a composite form, the refresh is needed
              // to update the form's derived values.  NOT calling refreshData because I only want to refresh this record!
              // I do NOT want to fire any events because the active panel has been saved and the other panels
              // marked needReload
              this.lmFormPagingService.refreshRecord(this.getDataView(), this.formUrlInfo.navigationContext)
                .subscribe((reloadDataView: LMDataView) => {
                  if (reloadDataView.serverLog) {
                    this.lmLoggerService.serverLog(reloadDataView.serverLog);
                  }
                  this._initDataView = reloadDataView;
                  this.formViewData.dataView = this._initDataView;
                  this.model.setData(this._initDataView, { notifyListeners: false });
                  this.allowUpdate = this.isModified(); // this is not updated if the form was not dirty, the save was enabled because a panel was dirty
                  this.updateToolbarState(this._initDataView, this.allowUpdate, true);

                  this.lmBusyIndicatorService.hideBusyIndicator();
                  if (callBack) {
                    callBack.next(true);
                    callBack.complete();
                  }
                });
            }
          } else {
            // error occurred saving panels. the panel component should have handled the error
            this.lmBusyIndicatorService.hideBusyIndicator();
            if (callBack) {
              callBack.next(false);
              callBack.complete();
            }
          }
        });
    } else {
      if (callBack) {
        callBack.next(true);
        callBack.complete();
      }
    }
  }

  // The Save button is already set based on model state or is enabled if a Create
  private executeSave(actionReferenceId: string, dataView: LMDataView, callBack?: Observer<boolean>, skipToast?: boolean) {

    this.waitForFormToBeReady().subscribe(() => {
      // execute transaction
      if (this.validateConfigRequiredFields(this.configRequiredFields)) {
        const formContext: LMFormContext = {
          formUrlInfo: this.formUrlInfo,
          formSpec: this.formSpec,
          formModel: this.model,
          placeholder: this.placeHolder,
        };

        let actionName: string;
        if (this.formSpec.independentForm && this.fromDataView) {
          // Use the composite form action to execute a save in independent form panel (LMCLIENT-23073)
          actionName = this.fromDataView.action;
        }

        const mingleInbox = ((this.lmContextService.inMingleInbox() || this.formUrlInfo.fromInbox) && this.isActionForm);
        let actionSpec = this.lmFormActionUtilService.getTargetAction(this.formSpec, dataView, actionName);
        const formActions = this.formSpec.busClassSpec.actions;
        const actionIndexes = this.getDataView().actionIndexes;

        // no need to check if the form is an 'actionIs' form because that transaction runs through the public api runActionSpec
        // Mingle Inbox:
        // Action requests are rendered as a standard form (instead of action form).
        // Go with the valid action (parameterised) in the dataview.action. isValidAction ignores parameterised action
        // and default update is not the correct action for action requests.
        // Mingle Inbox
        if (!mingleInbox && actionSpec.type === AppConstants.ACTION_TYPE_UPDATE && !this.lmActionService.isValidAction(actionSpec, formActions, actionIndexes, undefined, true)) {
          actionSpec = this.lmActionService.getDefaultUpdateAction(formActions, actionIndexes, true, true);

          if (actionSpec === null) {
            const message = Soho.Locale.translate('NoValidUpdateActionsAvailable');
            this.lmGlobalUtilService.displayToastMessage('', message, AppConstants.TRA_ACTION_FAILED);

            this.lmBusyIndicatorService.hideBusyIndicator();

            if (callBack) {
              callBack.next(false);
              callBack.complete();
            }
            return;
          }
        }

        // LMCLIENT-33564: BusTask/ActionForm direct link (Save is equivalent to Submit)
        const runActionForm = mingleInbox || this.isBusinessTaskForm || this.isActionForm;
        const observable = (runActionForm)
          ? this.lmTransactionService.runActionForm(formContext, actionSpec, dataView, [ dataView ])
          : this.lmFormTransactionService.runSaveAction(formContext, actionSpec, dataView);
        observable.subscribe(
          transactionState => {
            this.notifyManualRepSaveComplete(transactionState);
            if (transactionState.isError) {
              this.lmErrorUtilService.handleError(
                transactionState.response.message,
                transactionState.response.details,
                transactionState.response.status,
                transactionState.response.message);
            } else if (transactionState.isCanceled) {
              // TODO DPB
            } else {
              if (transactionState.postRegUrl) {
                const postRegUrl: string = transactionState.postRegUrl;
                this.anonymousRegistered = true; // this is to keep the form from checking save required!
                // lets call the callback without a timeout, this allows the step to update the form state
                // with the new step position so when the form unloads the correct step is save in the state.
                if (callBack) {
                  if (this.formContentComponent?.stepProcessComponent) {
                    this.formContentComponent?.stepProcessComponent.handlePostRegistration();
                  }
                  callBack.next(transactionState.isSuccess());
                  callBack.complete();
                }
                setTimeout(() => {
                  window.location.href = postRegUrl;
                }, 1);
                return;  // Returning here!!! The form is going to unload and we don't want to call the callback twice!
              } else {
                const result: LMActionResult = transactionState.getTransactionResult();

                if (result) {
                  this.handleTransactionStatus(result);

                  if (transactionState.isSuccess()) {

                    let isUpdateToCreate = false;
                    let createActionSpec: LMActionSpec = null;

                    // if the toolbar button used was STANDARD_TOOLBAR_SAVENEW on an update and the default create
                    // action exists and the create action does not have parameters and is not an action form,
                    // then allow the update to create
                    if (actionReferenceId === AppConstants.STANDARD_TOOLBAR_SAVENEW
                      && result.actionSpec.type === AppConstants.ACTION_TYPE_UPDATE) {
                      createActionSpec = this.lmActionService.getDefaultCreateAction(this.formSpec.busClassSpec.actions, result.dataView.actionIndexes);
                      isUpdateToCreate = (createActionSpec !== null && !createActionSpec.hasParameters && !createActionSpec.hasActionForm);
                    }

                    if (isUpdateToCreate) {
                      this.modelSourceEvent = { type: 'transaction' };
                      this.initDataView = result.dataView;
                      this.formStateKeyParams = null; // switching between update and create need to rebuild the state keys
                      this.runCreateAction(createActionSpec);

                    } else if (result.redirectUrl) {
                      // RedirectUrl is set in the transaction result for Create action, import action(?)
                      // and action forms that has completion navigation defined.
                      // TODO: Test action forms with completion navigation.
                      if (actionReferenceId === AppConstants.STANDARD_TOOLBAR_SAVENEW) {
                        // Save and New from a create action
                        // Reload the form and stay in the create mode.
                        this.modelSourceEvent = { type: 'paging' };
                        this.refreshData();

                      } else if (actionReferenceId === AppConstants.STANDARD_TOOLBAR_SAVECLOSE) {
                        this.model.setData(result.dataView, { source: { type: 'transaction' } });
                        this.location.back();

                      } else {
                        if (!this.lmContextService.getAsOfDate() && result.redirectUrl.indexOf('asofdate') !== -1) {
                          // Future dated record is created. This mimics canvas behavior.
                          // The user may or may not have the permission to 'set as of date'. So it is better to
                          // get back in history and not change the global context.
                          // Model state has to be cleared before going back in history so unsaved changes dialog will not be prompted.
                          this.model.setData(result.dataView, { notifyListeners: false, source: { type: 'transaction' } });
                          this.location.back();
                          // The toast code below will be executed.
                        } else {
                          this.modelSourceEvent = { type: 'transaction' };
                          this.initDataView = result.dataView;
                          this.formUrlInfo.resource.resourceId = this.formResource.resourceId;
                          this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(result.redirectUrl, true, true));
                          this.formStateKeyParams = null; // switching between create and update need to rebuild the state keys
                        }
                      }

                    } else if (result.completeIdentityOrigURL) {
                      const origURL = result.completeIdentityOrigURL;
                      this.model.setData(result.dataView, { source: { type: 'transaction' } });
                      this.lmGlobalUtilService.navigate(origURL, null, 'replace');
                    } else if (actionReferenceId === AppConstants.STANDARD_TOOLBAR_SAVECLOSE) {
                      this.model.setData(result.dataView, { source: { type: 'transaction' } });
                      this.location.back();

                    } else if (runActionForm) {
                      // Only SaveAsDraft is routed through standard save. pfActions will call runProcessFlowAction
                      this.refreshData();

                    } else {
                      this.modelSourceEvent = { type: 'transaction' };
                      this.initDataView = result.dataView;
                    }
                    this.notifyHandCodedTransactionComplete(transactionState);
                    if (!skipToast) {
                      const title = result.actionSpec.label;
                      const message = result.message || Soho.Locale.translate('ActionSuccessful');
                      this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
                    }
                  }
                }
              }
            }

            if (callBack) {
              //  this is needed because lm-form.component has a setTimeout in
              //  'set initDataView(dataView: LMDataView)' because of the timeout form does
              //  not update the model in time when switching from create to
              //  update mode
              setTimeout(() => {
                const success = transactionState.isSuccess();
                callBack.next(success);
                callBack.complete();

                if (!success && this.formContentComponent?.stepProcessComponent) {
                  this.formContentComponent?.stepProcessComponent.handleFormViewException(transactionState);
                }
              }, 1);
            }

            this.lmBusyIndicatorService.hideBusyIndicator();
          });
      } else {
        if (callBack) {
          callBack.next(false);
          callBack.complete();
        }

        this.lmBusyIndicatorService.hideBusyIndicator();
      }
    });
  }

  private runUILinkHttpUrl(httpUrl: LMHttpUrl, dataView: LMDataView): void {
    const option: string = (httpUrl.externalLink) ? 'external' : '';
    let url: string = this.lmFormatUtilService.formatMessageRule(httpUrl.messageRule, dataView);
    if (url.indexOf('web10x=true') > -1) {
      // Add csk parameters to the URL built by WebUrlBuilder for processflow
      url = this.lmUrlUtilService.propagateSessionKeys(url, '&');
    }
    this.lmGlobalUtilService.navigate(url, null, option);
  }

  public runNavigation(navigation: string, showAsPdf: boolean, openNewTab?: boolean) {
    const compiledTemplateNavUrl = urltemplate.parse(this.formUrlInfo.navigationUrl);
    const navigationUrl = compiledTemplateNavUrl.expand({
      resourceId: this.model.resourceId,
      navigationName: navigation
    });
    this.lmNavigationService.runNavigation(navigationUrl, undefined, { showAsPdf, openNewTab });
  }

  private runMatrixToggleDetail() {
    if (this.formContentComponent) {
      this.formContentComponent.runMatrixToggleDetail(this.showMatrixDetail);
    }
  }

  // TODO: consider merging this with LMToolbar.onBeforeRelatedActionsOpen()
  public runButtonRelatedAction(relActionUrl: string, actionName: string) {
    const resourceId = this.model.getData().resourceId;

    this.lmFormTransactionService.runButtonRelatedAction(relActionUrl, actionName, resourceId)
      .pipe(first()).subscribe((response: any) => {

        // use the dataview header for class level actions
        if (response?.actionSpec.type === AppConstants.ACTION_TYPE_CREATE
        ||  response?.actionSpec.type === AppConstants.ACTION_TYPE_SET
        ||  response?.actionSpec.type === AppConstants.ACTION_TYPE_IMPORT) {
          this.runRelatedAction(response.dataViewSet.header.resourceId, response.actionSpec);
          return;
        }

        if (response.dataViewSet.data.length === 0) {
          const message = Soho.Locale.translate('NoItemsAvailable');
          this.lmGlobalUtilService.displayToastMessage('', message, 'NoItemsAvailable');
        } else if (response.dataViewSet.data.length === 1) {
          this.runRelatedAction(response.dataViewSet.data[0].resourceId, response.actionSpec);
        } else {
            // TODO: need to determine how to display the multiple items
        }
      },
      error => {
        this.lmErrorUtilService.handleUnexpectedError(error, this.placeHolder);
      });
  }

  public runRelatedAction(resourceId: string, actionSpec: LMActionSpec) {
    this.lmBusyIndicatorService.showBusyIndicator();

    const parsedUrlTemplate = urltemplate.parse(this.formUrlInfo.relActionUrl);
    const relatedActionUrl = parsedUrlTemplate.expand({
      resourceId,
      actionName: actionSpec.name,
      formName:   actionSpec.formName ? actionSpec.formName : actionSpec.name
    });

    const relationAction = this.lmFormTransactionService.runRelatedAction(
      relatedActionUrl,
      actionSpec,
      resourceId
    ).subscribe((actionResult: LMActionFormDialogResult) => {
      if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
        const result = actionResult.transactionStateResult.getTransactionResult();
        // Success
        const title = result?.actionSpec?.label;
        const message = result.message;
        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);

        if (result?.isCompletionNavigation && result?.redirectUrl) {
          this.lmNavigationService.runNavigation(result.redirectUrl);
        } else {
          this.refreshData();
        }
      } else if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OPENERROR) {
        // TODO: needs better error handling
        this.lmBusyIndicatorService.hideBusyIndicator();
        this.lmErrorUtilService.handleError(actionResult.openError.message, actionResult.openError.details, actionResult.openError.status);
      }
    });

    this.subscriptionArray.push(relationAction);
  }

  private runCreateAction(actionSpec: LMActionSpec) {
    this.lmBusyIndicatorService.showBusyIndicator(); // Will be closed by dialog service or navigate to a new webpage

    let stepUpActionResult;
    if (this.stepUpActionResult) {
      stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }
    const createAction = this.lmFormTransactionService.runCreateAction(
      this.formUrlInfo,
      this.formSpec,
      actionSpec,
      this.getDataView(),
      stepUpActionResult
    ).subscribe((actionResult: LMActionFormDialogResult) => {
      if (!actionResult) {
        // Transaction service returns void if the action is not a parameter action
        return;
      }
      if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
        // Other transaction states are not checked here because the dialog is saved and closed only on successful transaction.
        const title = actionSpec.label;
        const message = actionResult.transactionStateResult.completedTransactionList[0].message;
        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);

        if (actionResult.transactionStateResult.completedTransactionList[0].isCompletionNavigation && actionResult.transactionStateResult.completedTransactionList[0].redirectUrl) {
          this.lmNavigationService.runNavigation(actionResult.transactionStateResult.completedTransactionList[0].redirectUrl);
        }
        // TODO:
        // this.refreshData();
      } else if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OPENERROR) {
        this.lmBusyIndicatorService.hideBusyIndicator();
        this.lmErrorUtilService.handleError(actionResult.openError.message, actionResult.openError.details, actionResult.openError.status);
      }
    });

    this.subscriptionArray.push(createAction);
  }

  private runUpdateAction(actionSpec: LMActionSpec) {
    this.lmBusyIndicatorService.showBusyIndicator();
    let stepUpActionResult;
    if (this.stepUpActionResult) {
      stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }

    const updateAction = this.lmFormTransactionService.runUpdateAction(
      this.formUrlInfo,
      this.formSpec,
      actionSpec,
      this.model,
      stepUpActionResult
    ).subscribe((actionResult: LMActionFormDialogResult) => {
      this.lmBusyIndicatorService.hideBusyIndicator();
      if (!actionResult) {
        // Transaction service returns void if the action is not a parameter action
        return;
      }

      if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
        // if we got this far then the action was successful
        const transactionState: LMTransactionState = actionResult.transactionStateResult;
        const result: LMActionResult = transactionState ? transactionState.getTransactionResult() : null;
        if (result) {
          const title = result?.actionSpec?.label;
          const message = result.message || Soho.Locale.translate('ActionSuccessful');
          this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
        }
        this.modelSourceEvent = { type: 'transaction' };

        if (result?.isCompletionNavigation && result?.redirectUrl) {
          this.lmNavigationService.runNavigation(result.redirectUrl);
        } else {
          this.refreshData();
        }
      } else if (actionResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OPENERROR) {
        this.lmBusyIndicatorService.hideBusyIndicator();
        this.lmErrorUtilService.handleError(actionResult.openError.message, actionResult.openError.details, actionResult.openError.status);
      }
    });

    this.subscriptionArray.push(updateAction);
  }

  private runDeleteAction(actionSpec: LMActionSpec) {

    this.lmBusyIndicatorService.showBusyIndicator();
    const formContext: LMFormContext = {
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      formModel: this.formModel,
      placeholder: this.placeHolder
    };

    // todo ppatton keeping the subscription should not be needed. runDeleteAction should only run once.
    const deleteAction = this.lmFormTransactionService.runDeleteAction(formContext, actionSpec, this.getDataView()).subscribe(
      (transactionState: LMTransactionState) => {
        this.lmBusyIndicatorService.hideBusyIndicator();
        if (transactionState.isError) {
          this.lmErrorUtilService.handleError(
            transactionState.response.message,
            transactionState.response.details,
            transactionState.response.status,
            transactionState.response.message);
        } else if (transactionState.isCanceled) {
          // What to do?
        } else {
          const result: LMActionResult = transactionState.getTransactionResult();
          this.handleTransactionStatus(result);

          if (transactionState.isSuccess()) {
            const title = result.actionSpec.label;
            const message = result.message || Soho.Locale.translate('ActionSuccessful');
            this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);

            this.model.setData(result.dataView, { source: { type: 'transaction' } }); // prevents the unsaved changes dialog pop from popping up when doing a delete.
            if (this.formSpec.dependentForm) {
              const formTransactionEvent = new LMFormTransactionEvent(this, transactionState.getTransactionResult());
              this.formTransactionEvent.emit(formTransactionEvent);
              this.notifyHandCodedTransactionComplete(transactionState);
            } else {
              this.location.back();
            }
          }
        }
      });

    this.subscriptionArray.push(deleteAction);
  }

  private runSetAction(actionSpec: LMActionSpec) {
    const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg') };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this._runSetAction(actionSpec);
      }
    });
  }

  private _runSetAction(actionSpec: LMActionSpec) {

    const formContext: LMFormContext = {
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      formModel: this.formModel, // DPB try to remove this
      placeholder: this.placeHolder
    };

    this.lmBusyIndicatorService.showBusyIndicator();

    const instanceAction = this.lmFormTransactionService.runSetAction(formContext, actionSpec, this.getDataView()).subscribe(
      (transactionState: LMTransactionState) => {
        if (transactionState.isError) {
          this.lmErrorUtilService.handleError(
            transactionState.response.message,
            transactionState.response.details,
            transactionState.response.status,
            transactionState.response.message);
        } else if (transactionState.isCanceled) {
          // What to do?
        } else {
          const result: LMActionResult = transactionState.getTransactionResult();

          if (transactionState.actionFormDialogSaved) {
            // Do NOT need to check if the transaction was a success because the dialog form
            // will stay open if it encounters an error.
            // Not using the transaction dataview because it is the parameter view.

            // Process redirectURL for onCompleteNavigation
            if (result.isCompletionNavigation && result.redirectUrl) {
              this.lmNavigationService.runNavigation(result.redirectUrl);
            }
          } else if (AppConstants.STATUS_COMPLETED === result.status || AppConstants.VIEW_EXCEPTION === result.status) {
            this.handleTransactionStatus(result);
          }

          if (transactionState.isSuccess()) {
            const title = result.actionSpec.label;
            const message = result.message || Soho.Locale.translate('ActionSuccessful');
            this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
          }
        }
        this.lmBusyIndicatorService.hideBusyIndicator();
      });

    this.subscriptionArray.push(instanceAction);
  }

  public runMatrixAction(actionTarget: LMMatrixActionTarget, actionSpec: LMActionSpec, dataView: LMDataView, callBack: Observer<boolean>) {
    this.waitForFormToBeReady().subscribe(() => {
      const formContext: LMFormContext = {
        formUrlInfo: this.formUrlInfo,
        formSpec: this.formSpec,
        formModel: this.model,
        placeholder: this.placeHolder
      };

      this.lmFormTransactionService.runMatrixAction(actionTarget, formContext, actionSpec, dataView).subscribe(
        transactionState => {
          if (transactionState.isError) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          } else if (transactionState.isCanceled) {
            // TODO DPB
          } else {
            const result: LMActionResult = transactionState.getTransactionResult();

            if (result) {
              if (result.status === AppConstants.VIEW_EXCEPTION) {
                this.lmErrorUtilService.handleError(result.message, result.details, result.status, result.message);
              } else if (result.status !== AppConstants.STATUS_COMPLETED && result.status !== AppConstants.CONFIRMATION_REQUIRED) {
                // If the status is confirmation required, it may be due to the user cancelling out of runtime confirmation.
                this.lmErrorUtilService.handleError(result.message, result.details, result.status, result.message);
              } else if (transactionState.isSuccess()) {
                const title = result.actionSpec.label;
                const message = result.message || Soho.Locale.translate('ActionSuccessful');
                this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
              }
            }
          }

          if (callBack) {
            callBack.next(transactionState.isSuccess());
            callBack.complete();
          }

          this.lmBusyIndicatorService.hideBusyIndicator();
        });
    });
  }

  private runInstanceAction(actionSpec: LMActionSpec) {
    const info: LMDialogInfo = { message:  Soho.Locale.translate('UnsavedChangesContinuingMsg') };
    this.handleUnsavedChanges(info).subscribe(response => {
      if (response) {
        this.zone.run(args => this._runInstanceAction(actionSpec));
      }
    });
  }

  private _runInstanceAction(actionSpec: LMActionSpec) {
    const formContext: LMFormContext = {
      formUrlInfo: this.formUrlInfo,
      formSpec:    this.formSpec,
      formModel:   this.formModel, // DPB try to remove this
      placeholder: this.placeHolder,
      sourceResourceId: (this.fromDataView) ? this.fromDataView.resourceId : undefined
    };

    if (this.stepUpActionResult) {
      formContext.stepUpActionResult = this.stepUpActionResult;
      this.stepUpActionResult = undefined;
    }
    this.lmBusyIndicatorService.showBusyIndicator();

    const instanceAction = this.lmFormTransactionService.runInstanceAction(formContext, actionSpec, this.getDataView()).subscribe(
      (transactionState: LMTransactionState) => {
        if (transactionState.isError) {
          if (!transactionState.isSSORedirecting) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          }
        } else if (transactionState.isCanceled) {
          // What to do?
        } else {
          const result: LMActionResult = transactionState.getTransactionResult();

          if (transactionState.actionFormDialogSaved) {
            // Do NOT need to check if the transaction was a success because the dialog form
            // will stay open if it encounters an error.
            // Not using the transaction dataview because it is the parameter view.

            // Process redirectURL for onCompleteNavigation
            if (result.isCompletionNavigation && result.redirectUrl) {
              this.lmNavigationService.runNavigation(result.redirectUrl);
              if (result.showAsPdf) {
                this.modelSourceEvent = { type: 'transaction' };
                this.refreshData();
              }
            } else {
              this.modelSourceEvent = { type: 'transaction' };
              const title = result.actionSpec.label;
              const message = result.message || Soho.Locale.translate('ActionSuccessful');
              this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
              this.refreshData();
            }
          } else {
            this.handleTransactionStatus(result);

            if (transactionState.isSuccess()) {
              if (result.isCompletionNavigation && result.redirectUrl) {
                this.lmNavigationService.runNavigation(result.redirectUrl);
                if (result.showAsPdf) {
                  this.modelSourceEvent = { type: 'transaction' };
                  this.refreshData();
                }
              } else if (this.runningSpecialActionList) {
                this.model.setData(result.dataView, { source: { type: 'transaction' } });
                this.runningSpecialActionList.refresh(null); // shouldnt this wait
                this.runningSpecialActionList = null;
              } else {
                this.modelSourceEvent = { type: 'transaction' };
                this.refreshData();
              }

              const title = result.actionSpec.label;
              const message = result.message || Soho.Locale.translate('ActionSuccessful');
              this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
            }
          }
        }

        if (transactionState.isSuccess()) {
          const formTransactionEvent = new LMFormTransactionEvent(this, transactionState.getTransactionResult());
          this.formTransactionEvent.emit(formTransactionEvent);
          this.notifyHandCodedTransactionComplete(transactionState);
        }
        this.lmBusyIndicatorService.hideBusyIndicator();
      });

    this.subscriptionArray.push(instanceAction);
  }

  private notifyHandCodedTransactionComplete(transactionState: LMTransactionState) {
    const htmlDocComp: LMHtmlUrlDocComponent = this.currentComponent.getHtmlUrlDocComponent();
    const transactionList: LMActionRequest[] = transactionState?.transactionRequestList;
    const actionName: string = (transactionList && transactionList.length > 0) ? transactionList[0]?.actionSpec?.name: '';
    if (htmlDocComp) {
      htmlDocComp.fireFormActionComplete(LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED,
        { message: '', resourceId: this.model.getData().resourceId, action: actionName });
    }
  }

  private runProcessFlowAction(actionReferenceId: string, sohoBusyIndicator?: SohoBusyIndicatorDirective) {

    const formContext: LMFormContext = {
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      formModel: this.formModel, // DPB try to remove this
      placeholder: this.placeHolder
    };

    // Get the process flow action
    const processFlowAction: LMProcessFlowAction = this._initDataView.processFlowActions
      .find(pfAction => pfAction.name === actionReferenceId);

    if (processFlowAction) {
      this.lmBusyIndicatorService.showBusyIndicator(sohoBusyIndicator);
      if (this.formContentComponent) {
        this.formContentComponent.runSaveAction().subscribe(
          () => {
            const actionSpec = this.lmActionService.getTargetAction({
              formSpec: this.formSpec,
              dataView: this._initDataView
            });

            this.lmFormTransactionService
              .runProcessFlowAction(formContext, processFlowAction, actionSpec, this.getDataView()).subscribe(
                (transactionState: LMTransactionState) => {
                  if (transactionState.isError) {
                  // Can be from mingle inbox that does not display dialog
                    if (this.formOptions.actionFormDialogData && this.formOptions.actionFormDialogData.actionDialog$) {
                      this.formOptions.actionFormDialogData.actionDialog$.next({
                        result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
                        transactionStateResult: transactionState
                      });
                    }
                    this.lmErrorUtilService.handleError(
                      transactionState.response.message,
                      transactionState.response.details,
                      transactionState.response.status,
                      transactionState.response.message);
                  } else if (transactionState.isCanceled) {
                  // DPB what to do
                    this.formOptions.actionFormDialogData.actionDialog$.next({
                      result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
                      transactionStateResult: transactionState
                    });
                  } else {
                    const result: LMActionResult = transactionState.completedTransactionList[0];
                    this.handleTransactionStatus(result);

                    if (AppConstants.STATUS_COMPLETED === result.status) {
                      if (this.formOptions.actionFormDialogData && this.formOptions.actionFormDialogData.actionDialog$) {
                        this.formOptions.actionFormDialogData.actionDialog$.next({
                          result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED,
                          transactionStateResult: transactionState
                        });
                        return;
                      }

                      // Action request work units will send the message over to the list to display.
                      // Other landmark work units will display message and go back in history.
                      if (transactionState.isSuccess()) {
                        const title = processFlowAction.name;
                        const message = result.message || Soho.Locale.translate('ActionSuccessful');
                        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);

                        this.model.setData(result.dataView, { source: { type: 'transaction' } });
                        if (this.lmContextService.inMingleInbox()) {
                          return;
                        }
                        if (this.formUrlInfo.fromInbox) {
                        // Go to home page
                          this.lmGlobalUtilService.navigateByUrl('/' + this.lmContextService.getContext().urlPdlOrDa + '/web/home');
                          return;
                        }
                        this.location.back();
                      }
                    } else if (AppConstants.VIEW_EXCEPTION === result.status) {
                      if (this.formOptions.actionFormDialogData && this.formOptions.actionFormDialogData.actionDialog$) {
                        this.formOptions.actionFormDialogData.actionDialog$.next({
                          result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
                          transactionStateResult: transactionState
                        });
                      }
                    }
                  }
                  this.lmBusyIndicatorService.hideBusyIndicator(sohoBusyIndicator);
                });
          });
      }
    }
  }

  private runCompareAction(sohoBusyIndicator?: SohoBusyIndicatorDirective) {
    const formContext: LMFormContext = {
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      formModel: this.formModel, // DPB try to remove this
      placeholder: this.placeHolder
    };

    const actionSpec = this.lmActionService.getTargetAction({
      formSpec: this.formSpec,
      dataView: this._initDataView
    });

    this.lmBusyIndicatorService.showBusyIndicator(sohoBusyIndicator);
    this.lmFormTransactionService
      .runCompareAction(formContext, actionSpec, this.getDataView()).subscribe(
        (transactionState: LMTransactionState) => {
        // Can be from mingle inbox that does not display dialog
          if (this.formOptions.actionFormDialogData && this.formOptions.actionFormDialogData.actionDialog$) {
            this.formOptions.actionFormDialogData.actionDialog$.next({
              result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
              transactionStateResult: transactionState
            });
          }

          if (transactionState.isError) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          } else if (transactionState.isCanceled) {
          // DPB what to do
          } else {
            const result: LMActionResult = transactionState.completedTransactionList[0];
            this.handleTransactionStatus(result);

            if (AppConstants.STATUS_COMPLETED === result.status) {
            // Bring up the compare dialog
              const dataset = this.buildActionRequestCompareData(result.dataView);
              // Create modal button
              const dialogId = 'CompareLog';
              const buttons = [
                {
                  id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
                  text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
                  click: (e, modal) => {
                    modal.close(true);
                  },
                  isDefault: true,
                }
              ];

              // Show the dialog button
              this.sohoModalDialogService
                .modal(LMAuditLogCompareDialogComponent, this.placeHolder, { fullsize: 'responsive' })
                .title(Soho.Locale.translate(dialogId))
                .buttons(buttons)
                .apply((dialogComponent) => {
                  dialogComponent.dataset = dataset;
                })
                .open();
            }
          }
          this.lmBusyIndicatorService.hideBusyIndicator(sohoBusyIndicator);
        });
  }

  private buildActionRequestCompareData(dataView: LMDataView): Array<{ FieldName: string }> {
    const fromDataView = dataView.compareDataView;
    const toDataView = dataView;
    const rows = [];

    dataView.compareFieldList.forEach(fieldId => {
      const fromField = fromDataView.fields[fieldId];
      const toField = toDataView.fields[fieldId];
      const specField = this.specFields[fieldId];
      let label = '';

      let fromValue = fromField.value;
      let toValue = toField.value;
      if (specField) {
        fromField.type = toField.type = specField.type;
        fromValue = this.toDisplayValue(fromField, specField);
        toValue = this.toDisplayValue(toField, specField);
        label = this.lmFormatUtilService.formatMessageRule(specField.label, dataView);
      }
      if (fromValue !== toValue) {
        rows.push({ FieldName: this.lmFieldUtilService.decodeFieldName(fieldId), Label: label, FromValue: fromValue, ToValue: toValue });
      }
    });
    return rows;
  }

  private toDisplayValue(lmField: LMField, lmSpecField: LMSpecField): string {
    const options: LMTransformOptions = { isCompoundField: this.lmFormatUtilService.isCompoundField(lmField, lmSpecField.isMultiselect) };

    if (lmField.hasOwnProperty('precision')) {
      options.precision = lmField.precision;
    }

    return this.lmFormatUtilService.toDisplayValueWithSpec(lmField.value, lmSpecField, options);
  }

  private runDefineAction(dataView: LMDataView, fieldId: string) {
    // Opening in a new tab for right now.
    //     // todo How to deal with dataView from independent form panel?
    //
    // // TODO: needs some work yet
    //     this.globalStorageModel.defineFieldId = fieldId;
    //     this.globalStorageModel.definePending = true;
    //
    //     // save the model cache so if user comes back any changes can be applied
    //     this.saveModelCache(true);

    this.lmFormRequestService.getDefineFormUrl(dataView.formUrl, fieldId, dataView).subscribe(
      (response: DefineFormSpecUrlResponse) => {
        if (response.status === 'COMPLETED') {
          this.lmGlobalUtilService.navigate(response.defineFormUrl, null, 'external');
        } else if (response.status === 'SYSTEM_EXCEPTION' && response.message === 'Define not yet available when database value doesn\'t exist.') {
          // object doesn't exist yet
          this.lmErrorUtilService.handleError(Soho.Locale.translate('DefineOnNonExistentValueError'));

        } else {
          this.lmErrorUtilService.handleError(response.message, response.details, response.status);
        }
      });
  }

  public getDataView(): LMDataView {
    return this.model ? this.model.getData() : null;
  }

  public isModified(): boolean {
    return this.formContentComponent ? this.formContentComponent.isModified() : false;
  }

  public canActivatePanel(fieldId): boolean {
    return this.formContentComponent ? this.formContentComponent.canActivatePanel(fieldId) : false;
  }

  /***********************************************
   * PRIVATE METHODS
   ***********************************************/
  private build(): void {
    this.lmLoggerService.log([ this, this.instanceId, 'build()' ]);

    if (this.isRouterOutletRootComponent) {
      if (this.hideTitleBar) {
        this.hideTitleManageScroll = true;
      } else {
        this.lmBannerHeaderCompRef.instance.fullPageScroll = true;
      }
    }

    /**
     * formSpec is king. If a formSpec is passed in as Input() then that
     * take precedence over the url.
     */
    if (this.formSpec) {
      if (!this.formSpec.isImplicit) {
        // if (this.formSpec.dependentForm || formSpec from a page menu panel) {
        //  // if it's a dependent form then no url could be used to get the url. So get the info
        //  // from the spec itself.
        //   this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec);
        // }
        //
        // if (!this.formUrlInfo) {
        //   console.error('No formUrlInfo was passed into the form component');
        // }

        // if (!this.formUrlInfo) {
        //   this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec);
        // }
      }

      this.formSpecLoaded();
    } else {
      this.loadFormSpec(this.router.url);
    }
  }

  private loadFormSpec(formUrl: string): void {
    this.lmLoggerService.trace([ this, this.instanceId, 'loadFormSpec()', 'formUrl: ' + formUrl ]);

    this.lmSpecService.getFormSpec(formUrl).subscribe((response: LMFormSpecResponse | LMSystemException) => {
      this.lmLoggerService.trace([ this, this.instanceId, 'LMFormService.getFormSpec2() complete', response ]);

      if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.hideBusyIndicator();
        const statusText = (response as LMSystemException).statusText;
        const details = (response as LMSystemException).details;
        this.lmErrorUtilService.handleError(statusText, details);
        return;
      }

      this.formUrlInfo = (response as LMFormSpecResponse).formUrlInfo;
      this.formSpec = (response as LMFormSpecResponse).formSpec;

      this.formSpecLoaded();
    },
    error => {
      this.lmErrorUtilService.handleUnexpectedError(error, this.placeHolder);
    });
  }

  private formSpecLoaded(): void {
    this.lmLoggerService.trace([ this, this.instanceId, 'formSpecLoaded()' ]);

    const bannerPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    const appDisplay = bannerPersonalization.appDisplay;
    const unsupportedPattern = this.doesSpecContainUnsupported4_0Patterns(this.formSpec);
    const forceXI = this.actionFormOptions && this.actionFormOptions.forceXI ? this.actionFormOptions.forceXI : false;
    this.setLegacyVariables(unsupportedPattern, appDisplay, this.lmContextService, this.lmHtmlPageUtilService, forceXI);
    if (this.lmBannerHeaderCompRef && this.lmBannerHeaderCompRef.instance && this.lmBannerHeaderCompRef.instance.is3_5 !== undefined) {
      this.lmBannerHeaderCompRef.instance.is3_5 = (this.url3_5 && this.url3_5.length > 0);
    }

    /*
     * set the formContentViewData - this will cause the form to be built,
     * displayed, and data loaded.
     */
    this.formViewData.formSpec = this.formSpec;
    this.formType = this.formSpec.busFormSpec.formType as LMFormType;

    this.initialize();

    // adding the id later since when the template is processed the spec is not ready. need to figure this out.
    // &(this._elRef.nativeElement).find("landmark-list").attr("id", this.listSpec.busListSpec.id);

    // have the formContent implementation _build
    // if (this.formSpec.busFormSpec.panelNavigation) {
    //   //    this.stepProcessComponent.build();
    // } else if (this.formStandardComponent) {   // safety
    //   this.formStandardComponent.build();
    // }
    //

    // this.keyParamContextResourceId = this.route.snapshot.params['resourceId'];
    // this.keyParamContextResourceId = this.formUrlInfo.resource.resourceId;

    if (this.loadData) {
      this.load();
    }
  }

  private get loadData(): boolean {
    if (this.isActionForm ||
        this.isBusinessTaskForm ||
        this.isChangePasswordForm ||
        this.actionFormOptions?.isDataViewFieldButtonForm) {
      // Timing again, init data view is undefined when the form is being initialized, but data is already retrieved
      // This is working now, as the dataview is back in the template and is not set in after view init.
      return (!this._initDataView);
    } else if (this.formSpec.dependentForm
      || this.formSpec.independentForm
      || this.isPageContextForm
      || this.isSearchForm
      || this.isResponseRequired
      || this.isMenuLayoutForm
      || this.isCompactForm
      || this.isSubForm) {
      return false;
    }
    return true;
  }

  // private _buildRelatedMenu(dataView: LMDataView) {
  //   let actionSpec = this._getTargetAction(dataView);
  //
  //   this.relatedMenuParams = {
  //     context: this.lmContextService.getContext(),
  //     busClassName: this.formSpec.busClassSpec.name,
  //     dataView: dataView,
  //     isCreateMode: (actionSpec !== null && actionSpec.type === AppConstants.ACTION_TYPE_CREATE)
  //   };
  //
  //   if (this.isRouterOutletRootComponent) {
  //     this._bannerHeaderCompRef.instance.toolbarOptions.relatedMenuParams = this.relatedMenuParams;
  //   }
  // }

  private buildToolbar(dataView: LMDataView) {
    this.lmLoggerService.trace([ this, this.instanceId, 'buildToolbar()' ]);

    /**
     * If the toolbar is on the header for this component then use the
     * headerToolbarAdapter service to set the HeaderToolbarTarget to
     * 'this' and pass in the toolbarOptions explicitly.
     */
    if (this.isRouterOutletRootComponent && !this.showToolbarOnForm) {
      // map inputs
      // ------------------------------------------------------------------------------------
      // if no variable in title then set static title here, else clear the title here and
      // when formLoaded is called then the title can be resolved and set.
      // ------------------------------------------------------------------------------------
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = this.formTitle;
      this.lmBannerHeaderCompRef.instance.screenId = this.formSpec.busFormSpec.name;
      this.lmBannerHeaderCompRef.instance.screenAutomationId = this.formSpec.automationId;
      this.lmBannerHeaderCompRef.instance.toolbarMoreSettings = this.toolbarMoreMenuSettings;

      // map outputs
      const toolbarButtonEventSubscription = this.lmBannerHeaderCompRef.instance.toolbarButtonEvent.subscribe((toolbarButtonEvent: LMToolbarButtonEvent) => {
        this.onToolbarButtonEvent(toolbarButtonEvent);
      });

      this.subscriptionArray.push(toolbarButtonEventSubscription);

      this.toolbarInitialized = true;
    }

    if (!this.url3_5 && !this.lmContextService.inMingleWidget()) {
      const formStateInfo: LMFormStateInfo = {
        dataView,
        disableAllActions: this.formSpec ? !!this.formSpec.disableAllActions : false,
        suppressStandardToolbar: this.formSpec ? !!this.formSpec.suppressStandardToolbar : false,
        calledOutActionsOnly: this.formSpec ? !!this.formSpec.calledOutActionsOnly : false,
        disableFieldOptions: this.formSpec ? !!this.formSpec.disableFieldOptions : false
      };
      this.lmFormToolbarService.buildToolbarButtons(this.formUrlInfo, this.formSpec, formStateInfo);
    }
  }

  private fireInitialValueRules(bindId: string): Observable<LMFields> {
    // this.lmLoggerService.log([this, this.instanceId, 'fireInitialValueRule', bindId, 'isFiringInitialValueRule', this.lmFormService.isFiringInitialValueRule]);
    // this.lmLoggerService.log([this, this.instanceId, 'fireInitialValueRule', 'start executing', bindId, 'isFiringInitialValueRule', this.lmFormService.isFiringInitialValueRule]);
    const skinnyDataView: LMDataView = this.model.getSkinnyData();
    const compiledFormRequestUrl = urltemplate.parse(this.formUrlInfo.formRequestUrl);
    let formRequestUrl = compiledFormRequestUrl.expand({ resourceId: this.model.formResourceId });
    if (this.formUrlInfo.navigationContext) {
      formRequestUrl = this.lmUrlUtilService.appendToQueryString(formRequestUrl, this.lmUrlUtilService.objectToQueryString(this.formUrlInfo.navigationContext));
    }
    const actionSpec = this.lmActionService.getTargetAction({
      formSpec: this.formSpec,
      dataView: skinnyDataView
    });

    const actionName = (actionSpec != null) ? actionSpec.name : null;

    return this.lmFormRequestService.fireInitialValueRules(formRequestUrl, bindId, skinnyDataView, actionName, this.formUrlInfo.sourceResource)
      .pipe(
        flatMap(response => this.model.setFields(response)),
        catchError(err => {
          this.lmFormService.initialValueRuleQueueCountDown();
          return throwError(err);
        }),
        finalize(() => {
          this.lmFormService.firingInitialValueRuleCompleted.next(bindId);
        })
      ) as Observable<LMFields>;
  }

  private runDrillAction(actionReference: LMBusActionReference) {
    // todo spec-url-refactor drills ane rel-actions can be done at a later time since they
    //  are small and lazily retrieved.
    const relActionUrl = actionReference.relActionUrl;
    // let relActionUrl = this.lmUrlUtilService.buildRelatedMenuActionUrl(this.formUrlInfo, actionReference);
    // if (!this.lmContextService.useNewSpecUrls()) {
    //   this.lmUrlInfoBuilderService.compareSpecUrls(this.formUrlInfo, this.formSpec.busFormSpec.name + '.relActionUrl', actionReference.relActionUrl, relActionUrl);
    //   relActionUrl = actionReference.relActionUrl;
    // }
    // todo spec-url-refactor compare relActionUrl to actionReference.relActionUrl
    this.lmSpecService.getDrillSpec(relActionUrl).pipe(first()).subscribe(response => {
      if (response.redirectUrl) {
        if (response.redirectUrl.indexOf('output=pdf') > -1) {
          this.lmGlobalUtilService.navigate(response.redirectUrl, null, 'external');

        } else if (response.redirectUrl.indexOf('/document/') > -1) {
          this.lmGlobalUtilService.navigate(response.redirectUrl);

        } else {
          this.lmGlobalUtilService.navigateByUrl(response.redirectUrl);
        }

        // save the model cache so if user comes back any changes can be applied
        if (actionReference.isDrillAround) {
          this.saveModelCache(true);
        }
      }
    },
    error => {
      this.lmErrorUtilService.handleUnexpectedError(error, this.placeHolder);
    });
  }

  private openCompactFormDialog(
    fieldId: string,
    title: LMMessageRule,
    layout: LMFormLayout,
    specFields?: LMSpecFields,
    originalCompoundFieldLayout?: LMCompoundFieldLayout,
    displayOnly = false,
    excludeOriginalField = false
  ) {
    // Passing the original, unchanged data and the current model so the form can be
    // set with the original data values and then have the current state applied, thus preserving the
    // state between the main form and the dialog form. Upon the return from the dialog form, the model from the
    // dialog form is returned so the state can be applied back to the main form.

    this.lmCompactFormDialogService.promptCompactFormDialog({
      placeholder: this.placeHolder,
      fieldId,
      title,
      layout,
      dataView: this.model.getOriginalData(),
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      specFields,
      model: this.model,
      originalCompoundFieldLayout,
      displayOnly,
      excludeOriginalField
    }).pipe(
      first()) // causes the subscription to complete after its messaged the first time
      .subscribe(
        (result: LMCompactFormResult) => {
          // result can be undefined if the user closes the modal by hitting the escape key, so adding a safety
          if (result && result.result === LMCompactFormDialogResult.RESPONSE_OK) {
            this.lmLoggerService.log(result.result);
            this.model.updateModelFromCompactForm(result.dataView, result.model, result.fieldId, result.bindIds);
          }
        }
      );
  }

  private openSubFormDialog(fieldId: string, title: LMMessageRule, busFormSpec: LMBusFormSpec) {
    // Passing the original, unchanged data and the current model so the form can be
    // set with the original data values and then have the current state applied, thus preserving the
    // state between the main form and the dialog form. Upon the return from the dialog form, the model from the
    // dialog form is returned so the state can be applied back to the main form.

    this.lmSubFormDialogService.promptSubFormDialog({
      placeholder: this.placeHolder,
      fieldId,
      title,
      busFormSpec,
      dataView: this.model.getOriginalData(),
      formUrlInfo: this.formUrlInfo,
      formSpec: this.formSpec,
      model: this.model
    }).pipe(
      first()) // causes the subscription to complete after its messaged the first time
      .subscribe(
        (result: LMSubFormResult) => {
          // result can be undefined if the user closes the modal by hitting the escape key, so adding a safety
          if (result) {
            if (result.result === LMSubFormDialogResult.RESPONSE_OK) {
              this.lmLoggerService.log(result.result);
              this.model.updateModelFromSubForm(result.dataView, result.model, result.bindIds);

            } else if (result.result === LMSubFormDialogResult.RESPONSE_ERROR && result.error) {
              this.lmErrorUtilService.handleError(result.error.message, result.error.details, result.error.status);
            }
          }
        }
      );
  }

  private openDataViewFieldButtonForm(formButton: LMButtonLayout, displayedSelectDialog = false) {
    const formUrl = this.lmUrlUtilService.buildUrl({
      resource: this.formResource
    });
    const fieldId: string = formButton.fieldId;
    const dataView: LMDataView = this.getDataView();

    this.lmFormRequestService
      .getDataViewFieldButtonFormInfo(formUrl, fieldId, dataView, displayedSelectDialog)
      .subscribe((formInfoResponse: LMDataViewDataFormInfoResponse) => {
        this.lmLoggerService.log([ this, this.instanceId, 'formRequestService.getDataViewDataFormInfo()', 'formInfoResponse=', formInfoResponse ]);

        if (formInfoResponse.openDialogForm) {
          this.openDataViewFormDialog({
            fieldId,
            busClassName: formInfoResponse.busClassName,
            busFormName: formInfoResponse.busFormName,
            actionName: formInfoResponse.actionName,
            dialogUrl: formInfoResponse.url,
            resourceId: formInfoResponse.fieldView.resourceId,
            fieldDataView: formInfoResponse.fieldView,
            fieldHasData: formInfoResponse.fieldHasData
          });
        } else if (formInfoResponse.openSelectRecord) {
          this.openSelectRecordDialog({
            formButton,
            busClassName: formInfoResponse.busClassName,
            busFormName: formInfoResponse.busFormName,
            busFormSpec: formInfoResponse.formSpec.busFormSpec,
            fieldDataView: formInfoResponse.fieldView,
            formSpec: formInfoResponse.formSpec
          });
        } else if (formInfoResponse.status === AppConstants.VIEW_EXCEPTION || formInfoResponse.status === AppConstants.STATUS_SYSTEM_ERROR) {
          this.lmErrorUtilService.handleError(formInfoResponse.message, formInfoResponse.details, formInfoResponse.status);
        }
      },
      (error) => {
        this.lmLoggerService.error([ this, this.instanceId, 'Error in getDataViewFieldButtonFormInfo', fieldId, error ]);
      });
  }

  private openDataViewFormDialog(formRequest: LMDataViewFormRequest): void {
    const formUrl = this.lmUrlUtilService.buildUrl({
      resource: this.formResource
    });
    const dataView: LMDataView = this.getDataView();
    let formDataView = formRequest.fieldDataView;

    const dataViewFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromHttpUrl(formRequest.dialogUrl);
    this.lmSpecService.getFormSpec(dataViewFormUrlInfo.specUrl).subscribe((response: LMFormSpecResponse | LMSystemException) => {
      this.lmLoggerService.trace([ this, this.instanceId, 'LMFormService.getFormSpec2() complete', response ]);

      if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
        this.hideBusyIndicator();
        const statusText = (response as LMSystemException).statusText;
        const details = (response as LMSystemException).details;
        this.lmErrorUtilService.handleError(statusText, details);
        return;
      }

      const formUrlInfo = (response as LMFormSpecResponse).formUrlInfo;
      const formSpec = (response as LMFormSpecResponse).formSpec;

      const actionSpec: LMActionSpec = formSpec.busClassSpec.actions ?
        formSpec.busClassSpec.actions.find(action => action.name === formRequest.actionName) :
        formSpec.busClassSpec.actionSpec;

      const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
      const dataUrl = urlCompiledTemplate.expand({ resourceId: formRequest.resourceId, actionName: formRequest.actionName });

      this.lmActionFormDialogService.getDataViewFieldButtonDataView(dataUrl, formDataView).subscribe((dialogDataViewResponse: LMDataView | LMSystemException) => {
        this.lmLoggerService.log([ this, this.instanceId, 'lmActionFormDialogService.getActionFormDialogDataView()', 'dialogDataViewResponse=', dialogDataViewResponse ]);

        formDataView = dialogDataViewResponse;
        if (formDataView.status !== AppConstants.STATUS_COMPLETED) {
          const exception: LMSystemException = dialogDataViewResponse as LMSystemException;
          this.lmErrorUtilService.handleError(exception.message, exception.details, exception.status, exception.statusText);
          return;
        }

        const actionFormOptions: LMActionFormOptions = {
          isDataViewFieldButtonForm: true,
          dataViewFieldButtonHasData: formRequest.fieldHasData
        };
        this.lmActionFormDialogService
          .runActionFormDialog(
            formUrlInfo,
            formSpec,
            actionSpec,
            formDataView,
            undefined,
            actionFormOptions
          ).subscribe((dialogResult: LMActionFormDialogResult) => {

            if (dialogResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED) {
              this.updateDataViewFieldButton(
                formUrl,
                dataView,
                formRequest.fieldId,
                Object.keys(dialogResult.transactionStateResult.getTransactionResult().dataView.fields).length ? dialogResult.transactionStateResult.getTransactionResult().dataView : dialogResult.transactionStateResult.transactionRequestList[0]?.dataView,
                formRequest.busClassName,
                formRequest.busFormName
              ).subscribe(); // Error handling and logging has been handled
            }

            if (dialogResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_CLEAR) {
              this.model.updateModelFromDataViewForm(formRequest.fieldId, '', this.model);
            }
          });
      });
    });
  }

  private openSelectRecordDialog(selectRecordRequest: LMDataViewSelectRecordRequest): void {
    const formUrl = this.lmUrlUtilService.buildUrl({
      resource: this.formResource
    });
    const dataView: LMDataView = this.getDataView();
    const fieldId: string = selectRecordRequest.formButton.fieldId;

    const selectRecordFormUrlInfo: LMFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(
      selectRecordRequest.formSpec, { fillOutTransactionUrlOnly: true });

    this.lmSelectRecordDialogService.promptSelectRecordDialog({
      formUrlInfo: selectRecordFormUrlInfo,
      formSpec: selectRecordRequest.formSpec,
      busFormSpec: selectRecordRequest.busFormSpec,
      dataView: selectRecordRequest.fieldDataView,
      fieldId,
      placeholder: this.placeHolder,
    })
      .pipe(first())
      .subscribe((selectRecordResult: LMSelectRecordResult) => {
        if (selectRecordResult.result === LMSelectRecordDialogResult.RESPONSE_OK) {
          this.updateDataViewFieldButton(
            formUrl,
            dataView,
            fieldId,
            selectRecordResult.dataView,
            selectRecordRequest.busClassName,
            selectRecordRequest.busFormName
          ).subscribe((successful: boolean) => {
            if (successful) {
              this.openDataViewFieldButtonForm(selectRecordRequest.formButton, true);
            }
          });
        }
      });
  }

  private updateDataViewFieldButton(formUrl: string, dataView: LMDataView, fieldId: string, fieldDataView: LMDataView, busClassName: string, busFormName: string): Observable<boolean> {
    // TODO: Needs better error handling
    return new Observable<boolean>(observer => {
      this.lmFormRequestService.getDataViewFieldButtonValue(formUrl, dataView, fieldId, fieldDataView, busClassName, busFormName)
        .subscribe((response: any) => {
          this.lmLoggerService.log([ this, this.instanceId, 'updateDataViewFieldButton()', 'response=', response ]);
          if (response.status === AppConstants.STATUS_COMPLETED) {
            this.model.updateModelFromDataViewForm(fieldId, response.fieldValue, this.model);
          } else if (response.status === AppConstants.VIEW_EXCEPTION || response.status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.lmErrorUtilService.handleError(response.message, response.details, response.status);
          }

          observer.next(response.status === AppConstants.STATUS_COMPLETED);
          observer.complete();
        });
    });
  }

  // private methods
  private _loadStepRecord(): Promise<LMDataView> {
    const self: LMFormComponent = this;
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      self.lmLoggerService.time({ id: 'LMForm.loadStepRecord() ' + self.instanceId });

      const resourceId = self.formUrlInfo.resource.dataResourceId;
      const actionName = self.formUrlInfo.action;
      const dataUrl = self.buildLoadRecordUrl(resourceId, actionName);

      self.lmFormPagingService.loadRecord(dataUrl).subscribe((response: any) => {
        self.lmLoggerService.timeEnd('LMForm.loadStepRecord() ' + self.instanceId);

        if (response.status === AppConstants.STATUS_COMPLETED) {
          self.initDataView = response;
          resolve(response);
        } else {
          self.lmLoggerService.error([ self, self.instanceId, 'loadStepRecord()', response ]);
          this.lmBusyIndicatorService.hideBusyIndicator();
          self.lmErrorUtilService.handleError(response.message, response.details, response.status, response.statusText);
        }
      });
    });
  }

  private _loadStandardRecord(): Promise<LMDataView> {
    this.lmLoggerService.log([ this, this.instanceId, '_loadStandardRecord()', 'start' ]);

    const self: LMFormComponent = this;
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      if (this.lmLoggerService.cskLog === 2) {
        self.lmLoggerService.time({
          id: `LoadStandardRecord-${self.instanceId}`,
          description: 'LOAD STANDARD RECORD',
          functionName: '_loadStandardRecord()',
          className: 'LMFormComponent',
          timingStart: 'LMFormComponent -> _loadStandardRecord()',
          timingEnd: 'LMFormComponent -> _loadStandardRecord()'
        });
      }
      let dataUrl = '';
      if (this.isCartView) {
        dataUrl = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec).initialDataUrl;
      } else {
        const resourceId = !self.fromDataView ? self.formUrlInfo.resource.dataResourceId : self.fromDataView.resourceId;
        const actionName = !self.fromDataView ? self.formUrlInfo.action : (self.formSpec.independentForm ? self.actionIsAction : null);
        dataUrl = self.buildLoadRecordUrl(resourceId, actionName);
      }

      self.lmFormPagingService.loadRecord(dataUrl).subscribe((response: any) => {
        if (response.status === AppConstants.STATUS_COMPLETED) {
          if (response.serverLog) {
            self.lmLoggerService.serverLog(response.serverLog);
          }

          self.initDataView = response;
          resolve(response);

        } else {
          self.lmLoggerService.error([ self, self.instanceId, 'loadStandardRecord()', response ]);
          this.lmBusyIndicatorService.hideBusyIndicator();
          self.lmErrorUtilService.handleError(response.message, response.details, response.status, response.statusText);
        }

        if (this.lmLoggerService.cskLog === 2) {
          self.lmLoggerService.timeEnd(`LoadStandardRecord-${self.instanceId}`);
        }
      },
      // TODO: cleanup deprecated usage of error callbacks in subscribe
      // Needs better error handling
      (error: any) => {
        if (this.lmLoggerService.cskLog === 2) {
          self.lmLoggerService.timeEnd(`LoadStandardRecord-${self.instanceId}`);
        }

        self.lmLoggerService.error([ self, self.instanceId, 'loadStandardRecord()', error ]);
        this.lmBusyIndicatorService.hideBusyIndicator();
        self.lmErrorUtilService.handleUnexpectedError(error, self.placeHolder);
      });
    });
  }

  // vonnyw: not sure if we still need this, commenting it out for now
  // private _processRecord(dataView: any) {
  //   this.lmLoggerService.time('LMForm.processRecord() ' + this.instanceId);

  // set here for availability, but don't do the processing that setDataView has
  //     if (dataView) {
  // //            var wizardState = self._getWizardState();
  // //
  // //            if (wizardState != undefined && wizardState.operation != undefined)
  // //                self.dataView = wizardState.dataview;
  // //            else
  //       this.dataView = dataView;
  //     }

  /**
   * This must be in place before any widgets are built. If not the banner
   * will get updated before this handler has a chance to reject invalid
   * titlechange events.
   */
  // TODO:        $(self.element).on("listtitlechanged formtitlechanged pagetitlechanged", function(e)
  //        {
  //            if (e.target !== e.currentTarget)
  //            {
  //                /**
  //                 * only want top level titlechanged events to get to the
  //                 * landmarkBanner event handler.
  //                 */
  //                e.stopPropagation();
  //            }
  //        });

  // TODO:        self._buildForm();

  // LMCLIENT-11053
  // Not sure why this condition included implementsDashBoardView. That was causing _setupEventHandlers()
  // to be called twice on a composite form context form that implementsDashBoardView. Which caused 2
  // event handlers for each action for those forms. Which was causing 2 transactions to attempt to be
  // executed.
  // If this form implementsDashBoardView then self.isDetailSection is already true and any "dependent"
  // forms will be covered by that.
  // if (self.isDetailSection || self.isDetailFields || self.options.busFormSpec.implementsDashBoardView)
  // TODO:        if (self.isDetailSection || self.isDetailFields)
  //        {
  //            self._setupEventHandlers();
  //
  //            window.setTimeout(function()
  //            {
  //                self.element.inforForm();
  //            }, 1);
  //        }

  // run layout if form is not of these conditions
  // setDataView will run layout after the data view is set, but only when these conditions are true

  // TODO:        if (!self.isDetailSection && !self.isDetailFields) // && !self.options.busFormSpec.implementsDashBoardView)
  //        {
  //            self._formLayout(self.element);
  //        }

  //   this.lmLoggerService.timeEnd('LMForm.processRecord() ' + this.instanceId);
  // }

  private formDataLoaded(): void {
    this.lmLoggerService.log([ this, this.instanceId, 'formDataLoaded()', 'start' ]);
    // // build options for composite form tabs
    // if (this.formType === 'Composite') {
    //   this.buildFormOptions(this.formSpec.busFormSpec);
    // }

    // -------------------------------------------------------------------------------------
    // This needs to be updated when the dataView changes (due to next/prev
    // or resetting of _initDataView for related/dependent forms).
    // -------------------------------------------------------------------------------------
    this.formTitle = this.lmFormatUtilService.formatMessageRule(this.formSpec.busFormSpec.title, this._initDataView, this.specFields);
    if (!_.isEmpty(this.formSpec.busFormSpec.title.variables)
      && (!this.isRouterOutletRootComponent && this.formType === 'Standard')) {
      this.titleChanged.emit(this.formTitle);
    }

    if (this.model) {
      this.lmLoggerService.log([ this, this.instanceId, 'formDataLoaded()', 'this.model.setData()' ]);

      this.model.setData(this._initDataView, {
        source: this.modelSourceEvent,
        filterCriteria: this.formOptions.filterCriteria,
        alphaDefaultFilterCondition: this.formOptions.defaultAlphaFilterCondition
      });

      // need to reset this flag!
      this.modelSourceEvent = null;

      this.formResource = new FormResource({ resourceId: this.model.formResourceId });
      this.formComponentId = this.formSpec.busFormSpec.name;
      this.loadComponentState();
    }

    if (!this.formSpec.dependentForm) {
      if (!this.toolbarInitialized) {
        this.buildToolbar(this._initDataView);
      } else {
        this.updateToolbarState(this._initDataView, this.allowUpdate, true);
      }
    }

    this.formViewData.dataView = this._initDataView;

    // this.setRelatedDataView(this.formViewData.dataView);
    this.formDataLoadedComplete = true;

    if (!this.isSearchForm && !this.isPageContextForm) {
      this.subscribeToFormChanges();
    }

    this.checkApplyModelCache(this.model.globalCache);

    this.formRendered.emit(this);

    if (this.isRouterOutletRootComponent || this.isActionForm || this.isBusinessTaskForm || this.isMingleInbox) {
      this.sendShortcut();
      this.sendBusinessContext(this.formViewData.dataView);
    }

    // -----------------------------------------------------
    // form should be considered displayed as any display
    // in a dialog is handled there.
    // -----------------------------------------------------
    this.formDisplayed.emit(this);

    // In action form dialog, once form data is loaded, listen to OK clicks
    if (this.formOptions.actionFormDialogData && this.formOptions.actionFormDialogData.actionDialog$ && !this.formSpec.isScheduleForm) {
      this.subscribeToActionDialog();
    }

    if (this._initDataView.stepUpActionResult) {
      if (this._initDataView.stepUpActionResult.type?.toLowerCase() === 'mfa') {
        // process return from mfa - Mostly a HTTP get in this case
        this.stepUpActionResult = this._initDataView.stepUpActionResult;
        this._initDataView.stepUpActionResult = undefined;
        this.processMFAReturn();
      } else {
        // Process the action result in the case of step up authentication - HTTP Post action
        this.processStepUpAuthActionResult(this._initDataView.stepUpActionResult);
      }
    }

    this.lmLoggerService.log([ this, this.instanceId, 'formDataLoaded()', 'end' ]);
  }

  private processStepUpAuthActionResult(actionResult: LMActionResult) {
    if (AppConstants.CONFIRMATION_REQUIRED === actionResult.status) {
      // TODO: Handle confirmation required
      const formContext: LMFormContext = {
        formUrlInfo: this.formUrlInfo,
        formSpec:    this.formSpec,
        formModel:   this.formModel, // DPB try to remove this
        placeholder: this.placeHolder,
        sourceResourceId: (this.fromDataView) ? this.fromDataView.resourceId : undefined
      };
      this.lmFormTransactionService.processStepUpAuthActionResult(formContext, actionResult, this._initDataView).subscribe(
        (transactionState: LMTransactionState) => {
          // Processed the result. Remove from dataview.
          this._initDataView.stepUpActionResult = undefined;
          if (transactionState.isError) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
          } else if (transactionState.isCanceled) {
            // What to do?
          } else {
            const result: LMActionResult = transactionState.getTransactionResult();
            this.handleTransactionStatus(result);

            if (transactionState.isSuccess()) {
              const title = result.actionSpec.label;
              const message = result.message || Soho.Locale.translate('ActionSuccessful');
              this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
              this.refreshData();
            }
          }
        });
    } else {
      if (AppConstants.STATUS_COMPLETED === actionResult.status) {
        const title = actionResult.actionSpec.label;
        const message = actionResult.message || Soho.Locale.translate('ActionSuccessful');
        this.lmGlobalUtilService.displayToastMessage(title, message, AppConstants.TRA_ACTION_COMPLETED);
        this.refreshData();
      } else {
        this.handleTransactionStatus(actionResult);
        // Processed the result. Remove from dataview.
        this._initDataView.stepUpActionResult = undefined;
      }
    }
  }

  private processMFAReturn() {
    if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_FUNCTION) {
      this.runInstanceAction(this.stepUpActionResult.actionSpec);
    } else if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_CREATE) {
      this.runCreateAction(this.stepUpActionResult.actionSpec);
    } else if (this.stepUpActionResult.actionSpec.type === AppConstants.ACTION_TYPE_UPDATE) {
      this.runUpdateAction(this.stepUpActionResult.actionSpec);
    }
  }
  // private setRelatedDataView(dataView: LMDataView): void {
  //   // if (this.formType === AppConstants.FORMTYPE_COMPOSITE) {
  //   //   if (this.compositeComponent) {
  //   //     this.compositeComponent.fromDataView = dataView;
  //   //   }
  //   // this.stepProcessComponent.fromDataView = dataView;
  //
  //   // if (this.stepProcessComponent) {
  //   //   this.stepProcessComponent.fromDataView = dataView;
  //   // }
  //   // else {
  //   //   this.compositeComponent.fromDataView = dataView;
  //   // }
  //   // }
  // }

  private updateToolbarState(dataView: LMDataView, isModified?: boolean, includeSaveAndNew?: boolean): void {
    const formStateInfo: LMFormStateInfo = {
      dataView,
      isModified: this.model.isDirty || isModified,
      isCreateMode: this.model.isCreateAction,
      includeSaveAndNew,
      showMatrixDetail: this.showMatrixDetail,
      disableAllActions: this.formSpec && this.formSpec.disableAllActions,
      calledOutActionsOnly: this.formSpec && this.formSpec.calledOutActionsOnly,
      suppressStandardToolbar: this.formSpec && this.formSpec.suppressStandardToolbar
    };

    if (this.isRouterOutletRootComponent && !this.showToolbarOnForm) {
      // reset the section title in the banner ref, according to the current data view (for http://jira.lawson.com/browse/LMCLIENT-20304 wasn't updating from create to update dataview)
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = this.lmFormatUtilService.formatMessageRule(this.formSpec.busFormSpec.title, this.getDataView(), this.specFields);
    }

    this.lmFormToolbarService.updateToolbarState(this.formUrlInfo, this.formSpec, formStateInfo);
  }

  // /**
  //  * TODO move this into a service maybe?
  //  * @param busFormSpec
  //  */
  // private buildFormOptions(busFormSpec: LMBusFormSpec) {
  //   // The visibility condition is evaluated and only the tabs that are visible are included
  //   // in the collection
  //   // TODO: Identify when conditions are to be evaluated again and rebuild the tabs collection
  //   // TODO: An observable can be used to call this method to rebuild the collection
  //
  //   this.verticalTabs = false;
  //   this.contextForm = undefined;
  //
  //   if (busFormSpec.contextForm) {
  //     this.contextForm = busFormSpec.contextForm;
  //   }
  //
  //   if (!busFormSpec.panelNavigation && !busFormSpec.isWizard) {
  //     this.verticalTabs = (busFormSpec.showTabsOnLeft) ? busFormSpec.showTabsOnLeft : false;
  //   }
  //
  //   let compositeFormOptions: CompositeFormOptions = {panels: this.panels, contextForm: this.contextForm, verticalTabs: this.verticalTabs};
  //   this.formOptions.compositeFormOptions = compositeFormOptions;
  // }

  // private _getActionMenuActions(): Array<any> {
  //   let actionMenuActions: Array<any> = [];
  //   let actions = this.formSpec.busClassSpec.actions;
  //
  //   for (let i = 0, l = actions.length; i < l; i++) {
  //     let action = actions[ i ];
  //
  //     if (action && action.restricted) {
  //       actionMenuActions.push('');
  //     } else {
  //       actionMenuActions.push(action);
  //     }
  //   }
  //
  //   return actionMenuActions;
  // }

  // private _getActionTypes(dataView: LMDataView): any {
  //   let actionTypes: any = null;
  //   let actionSpec = this._getTargetAction(dataView);
  //   let isCreate = false;
  //
  //   if (actionSpec && actionSpec.type === AppConstants.ACTION_TYPE_UPDATE) {
  //     actionTypes = [];
  //     actionTypes.push(
  //       AppConstants.ACTION_TYPE_DELETE,
  //       AppConstants.ACTION_TYPE_FUNCTION,
  //       AppConstants.ACTION_TYPE_UPDATE
  //     );
  //   } else if (actionSpec && actionSpec.type === AppConstants.ACTION_TYPE_CREATE) {
  //     actionTypes = [];
  //     actionTypes.push(
  //       AppConstants.STANDARD_TOOLBAR_SAVE
  //     );
  //     isCreate = true;
  //   }
  //
  //   return { actionTypes: actionTypes, isCreate: isCreate };
  // }

  private initialize(): void {
    this.lmLoggerService.log([ this, this.instanceId, 'initialize()' ]);
    // if (this.formSpec.busFormSpec.panelNavigation) {
    //   this.isPanelNavigation = true;
    // }
    // if (this.formSpec.busFormSpec.isWizard) {
    //   this.isWizard = true;
    // }

    if (!this._specFields) {
      this._specFields = this.formSpec.busFormSpec.fields;
    }
    this.configRequiredFields = this.formSpec.busFormSpec.requiredFields;
    const modelOptions: LMModelOptions = { formUrlInfo: this.formUrlInfo, formSpec: this.formSpec };

    this.lmLoggerService.log([ this, this.instanceId, 'initialize()', 'new LMModel()' ]);

    this.model = new LMModel(this.lmModelServiceAdapter, modelOptions);
    this.model.populate(this.specFields);
    // Execute procedures to load intial data
    if (this._initDataView) {
      this.formDataLoaded();
    }

    // TODO: CandidateSelfService contextForm is undefined
    // Example URL: (CLICK CREATE)
    // /hcm/web/list/JobPosting?csk.HROrganization=7004&csk.JobBoard=EXTERNAL&csk.ng=true

    if (this.formType === 'Composite') {
      if (!this.formSpec.busFormSpec.panels) {
        this.layout = this.formSpec.busFormSpec.contextForm.busFormSpec.busFormLayoutSpec.layout;
      }
      if (!this.formSpec.busFormSpec.contextForm) {
        this.compositeFormWithOutContext = true;
      }
    } else if ('Chart' === this.formType || 'Matrix' === this.formType || this.isActionFormWithSections) {
      // at this point no layout is required for an instance chart or matrix
      // No layout required for isActionFormWithSections
    } else {
      this.layout = this.formSpec.busFormSpec.busFormLayoutSpec.layout;
    }

    if (this.heightShouldBeNull()) {
      this.styleHeight = null;
    }

    if (this.bannerInRoute) {
      this.styleHeight = 'calc(100% - 40px)';
    }

    // this.layout = this.formType === 'Composite'
    //  ? this.formSpec.busFormSpec.contextForm.layout
    //  : this.formSpec.busFormSpec.busFormLayoutSpec.layout;

    // -------------------------------------------------------------------------
    // Setup toolbar service observable to build and update the toolbar state.
    // When any call to the service modifies it's internal toolbar buttons
    // then this will get messaged and the lists toolbar will be updated
    // with the new buttons through an angular template sync pipe
    // -------------------------------------------------------------------------
    if (this.isRouterOutletRootComponent && !this.showToolbarOnForm) {
      this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmFormToolbarService.getToolbarButtonsObservable();
    } else {
      this.toolbarButtons = this.lmFormToolbarService.getToolbarButtonsObservable();
    }
    // (this.isRouterOutletRootComponent ) ?
    //     this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmFormToolbarService.getToolbarButtonsObservable() :
    //     this.toolbarButtons = this.lmFormToolbarService.getToolbarButtonsObservable();

    this.initialBuildComplete = true;
  }

  private heightShouldBeNull(): boolean {
    if (!this.url3_5 && this.lmContextService.inMingleWidget()) {
      return false;
    }

    return !(this.formType !== LMFormType.SEARCH && this.formType !== LMFormType.PAGE_CONTEXT);
  }

  // used in template
  public get isCompositeForm() {
    return this.formSpec.busFormSpec.formType === 'Composite';
  }

  public get isActionFormWithSections() {
    return this.isActionForm && this.formSpec.busFormSpec.panels;
  }

  private get isMatrixForm() {
    return this.formSpec.busFormSpec.formType === 'Matrix';
  }

  private get isWizardForm() {
    return this.formSpec.busFormSpec.formType === 'Wizard';
  }

  public get isPageContextForm(): boolean {
    return this.lmFormSpecUtilService.isPageContextForm(this.formSpec);
  }

  private get isSearchForm(): boolean {
    return this.lmFormSpecUtilService.isSearchForm(this.formSpec);
  }

  private get isActionForm(): boolean {
    return this.lmFormSpecUtilService.isActionForm(this.formSpec);
  }

  private get isResponseRequired(): boolean {
    return this.lmFormSpecUtilService.isResponseRequired(this.formSpec);
  }

  private get isMenuLayoutForm(): boolean {
    return this.lmFormSpecUtilService.isMenuLayoutForm(this.formSpec);
  }

  private get isCompactForm(): boolean {
    return this.lmFormSpecUtilService.isCompactForm(this.formSpec);
  }

  private get isSubForm(): boolean {
    return this.lmFormSpecUtilService.isSubForm(this.formSpec);
  }

  private get isBusinessTaskForm(): boolean {
    return this.lmFormSpecUtilService.isBusinessTask(this.formSpec);
  }

  get isMingleWidget(): boolean {
    return this.lmContextService.inMingleWidget();
  }

  get isMingleInbox(): boolean {
    return this.lmContextService.inMingleInbox();
  }

  private get isChangePasswordForm(): boolean {
    return this.lmFormSpecUtilService.isChangePasswordForm(this.formSpec);
  }

  private get useFormState(): boolean {
    return this.isCompositeForm // which includes step control form
      || this.isMatrixForm
      || this.isWizardForm
      || this.pageContextForm;
  }

  /**
   * Lazily builds and returns the LMFormStateKeyParams object.
   * @returns
   */
  private buildFormStateKeyParams(): LMFormStateKeyParams {
    if (!this.formStateKeyParams) {
      const routeResourceId = this.formSpec.anonymousId === this.lmContextService.getActorId() ?
        this.buildAnonymousResourceId() : this.formUrlInfo.resource.resourceId;

      this.formStateKeyParams = this.lmStateHelperService.buildFormStateKeyParams(routeResourceId, this.formSpec);
    }

    return this.formStateKeyParams;
  }

  private buildAnonymousResourceId(): string {
    return this.formUrlInfo.resource.busClassName + '.' + this.formUrlInfo.resource.uiResourceName;
  }

  private buildFormPersonalizationKeyParams(): LMFormPersonalizationKeyParams {
    if (!this.formPersonalizationKeyParams) {
      this.formPersonalizationKeyParams = new LMFormPersonalizationKeyParams();
      this.formPersonalizationKeyParams.storageKey = this.lmFormSpecUtilService.storageKey(this.formSpec);
      this.formPersonalizationKeyParams.resourceId = this.getNormalizedResourceId();
      this.formPersonalizationKeyParams.contextResourceId = this.formUrlInfo.resource.resourceId;
      if (this.lmContextService.getAsOfDate()) {
        this.formStateKeyParams.asOfDate = this.lmContextService.getAsOfDate();
      }
    }

    return this.formPersonalizationKeyParams;
  }

  private buildGlobalStorageKeyParams(): LMKeyParamsBase {
    if (!this.globalStorageKeyParams) {
      this.globalStorageKeyParams = new LMGlobalStorageKeyParams();
      this.globalStorageKeyParams.storageKey = this.lmFormSpecUtilService.storageKey(this.formSpec);
      this.globalStorageKeyParams.resourceId = this.getNormalizedResourceId();
      this.globalStorageKeyParams.contextResourceId = this.formUrlInfo.resource.resourceId;
      if (this.lmContextService.getAsOfDate()) {
        this.formStateKeyParams.asOfDate = this.lmContextService.getAsOfDate();
      }
    }

    return this.globalStorageKeyParams;
  }

  private getNormalizedResourceId(): string {
    const formResource: FormResource = new FormResource({
      busClassName: this.formSpec.busClassSpec ? this.formSpec.busClassSpec.name : 'PageContextForm',
      formName: this.formSpec.busFormSpec.name
    });
    return formResource.resourceId;
  }

  private runValidateDataViewField() {
    this.waitForFormToBeReady().subscribe(() => {
      if (!this.validateConfigRequiredFields(this.configRequiredFields)) {
        return;
      }
      const actionSpec = this.formOptions.actionFormDialogData.actionSpec;
      const formContext: LMFormContext = {
        formUrlInfo: this.formUrlInfo,
        formSpec: this.formSpec,
        formModel: this.model,
        placeholder: this.placeHolder
      };

      this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
      this.lmFormTransactionService.runValidateFormPanel(formContext, actionSpec, this.getDataView(), '').subscribe(
        (transactionState: LMTransactionState) => {
          if (transactionState.isError) {
            this.lmErrorUtilService.handleError(
              transactionState.response.message,
              transactionState.response.details,
              transactionState.response.status,
              transactionState.response.message);
            this.formOptions.actionFormDialogData.actionDialog$.next({
              result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
              transactionStateResult: transactionState
            });
          } else if (transactionState.isCanceled) {
            // Nothing to do
          } else if (transactionState.isSuccess()) {
            this.closeActionFormDialog(transactionState, null);
          } else {
            this.handleTransactionStatus(transactionState.getTransactionResult());
            this.formOptions.actionFormDialogData.actionDialog$.next({
              result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
              transactionStateResult: transactionState
            });
          }
          this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        });
    });
  }

  private subscribeToActionDialog() {
    this.formOptions.actionFormDialogData.actionDialog$
      // Do not do first here. This subscription will be active until dialog is closed.
      // The dialog service will complete and close this subject.
      .subscribe((actionDlgResult: LMActionFormDialogResult) => {
        if (actionDlgResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OK
          || actionDlgResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_OK2) {
          this.waitForFormToBeReady().subscribe(() => {
            if (!this.validateConfigRequiredFields(this.configRequiredFields)) {
              this.formOptions.actionFormDialogData.actionDialog$.next({
                result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
              });
            } else {
              const actionSpec = this.formOptions.actionFormDialogData.actionSpec;
              const parameterView = this.getDataView();
              const dataViewList: LMDataView[] = [];
              const origTransactionState = actionDlgResult.transactionStateResult;

              // Merge schedule information
              if (actionDlgResult.scheduleView) {
                parameterView.scheduleView = actionDlgResult.scheduleView;
              }

              if (actionDlgResult.actionRequestArray && actionDlgResult.actionRequestArray.length > 1) {
                for (let i = 0, l = actionDlgResult.actionRequestArray.length; i < l; i++) {
                  dataViewList.push(actionDlgResult.actionRequestArray[i].dataView);
                }
              } else {
                dataViewList.push(parameterView);
              }

              const formContext: LMFormContext = {
                formUrlInfo: this.formUrlInfo,
                formSpec: this.formSpec,
                formModel: this.model,
                placeholder: this.placeHolder
              };

              // Request action has two kinds of save action. The save mode is passed to the backend to perform either a draft save or a submit save.
              if (actionDlgResult.pfActionRequestSaveMode) {
                formContext.actionRequestMode = actionDlgResult.pfActionRequestSaveMode;
              }

              this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

              if (Object.keys(formContext.formModel.getManuualRepFields()).length > 0) {
                new Observable<boolean>(observer => {
                  this.lmGlobalUtilService.runSaveManualReps(observer, this.lmHtmlUrlDocService.getManualRefCompRefs());
                }).subscribe(data => {
                  if (data) {
                    this.runActionFormTransaction(formContext, actionSpec, parameterView, dataViewList, origTransactionState);
                  } else {
                    // clean up the dialog so it can be resubmitted once the errors are fixed.
                    if (origTransactionState) {
                      origTransactionState.cancel();
                    }
                    this.formOptions.actionFormDialogData.actionDialog$.next({
                      result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
                    });
                    this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
                  }
                });
              } else {
                this.runActionFormTransaction(formContext, actionSpec, parameterView, dataViewList, origTransactionState);
              }

            }
          });
        } else if (actionDlgResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_PFACTION) {
          this.waitForFormToBeReady().subscribe(() => {
            this.runProcessFlowAction(actionDlgResult.pfActionName, this.sohoBusyIndicator);
          });
        } else if (actionDlgResult.result === LMActionFormDialogResultCode.ACTION_FORM_DIALOG_COMPARE) {
          this.runCompareAction(this.sohoBusyIndicator);
        } else if (actionDlgResult.result === LMActionFormDialogResultCode.ACTION_FORM_VALIDATE_ONLY) {
          this.runValidateDataViewField();
        }
      });
  }

  private runActionFormTransaction(formContext: LMFormContext, actionSpec: LMActionSpec, parameterView: LMDataView, dataViewList: LMDataView[], origTransactionState: LMTransactionState) {
    this.lmTransactionService.runActionForm(formContext, actionSpec, parameterView, dataViewList).subscribe(
      (transactionState: LMTransactionState) => {
        this.notifyManualRepSaveComplete(transactionState);
        if (transactionState.isError) {
          this.lmErrorUtilService.handleError(
            transactionState.response.message,
            transactionState.response.details,
            transactionState.response.status,
            transactionState.response.message);
          if (origTransactionState) {
            origTransactionState.cancel();
          }
          this.formOptions.actionFormDialogData.actionDialog$.next({
            result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
            transactionStateResult: transactionState
          });
        } else if (transactionState.isCanceled) {
          // DPB this needs to update the audit fields like reason code

          this.formOptions.actionFormDialogData.actionDialog$.next({
            result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
            transactionStateResult: transactionState
          });
        } else if (transactionState.isSuccess()) {
          this.closeActionFormDialog(transactionState, origTransactionState);
        } else {
          // List, multiple dataviews. Some succeeded, some failed and transaction state is finished.
          if (transactionState.completedTransactionList.length === 1) {
            this.handleTransactionStatus(transactionState.getTransactionResult());
            this.formOptions.actionFormDialogData.actionDialog$.next({
              result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
              transactionStateResult: transactionState
            });

          } else {
            this.handleMultipleActionExceptionTransactions(transactionState, origTransactionState);
          }
        }
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
      });
  }

  private  notifyManualRepSaveComplete(transactionState: LMTransactionState) {
    // If this is a screen that uses the lawson-api.js we need to fire an event that informs the iframe screen the save in either saved or not
    if (this.currentComponent && this.currentComponent.getHtmlUrlDocComponent()) {

      const refs: LMManualRepresentationComponent[] = this.lmHtmlUrlDocService.getManualRefCompRefs();
      for (const item of refs) {
        item.getLmHtmlUrlDocComponent().fireLandmarkFormSaveComplete(transactionState.isSuccess());
      }
    }
  }

  private handleMultipleActionExceptionTransactions(transactionState: LMTransactionState, origTransactionState: LMTransactionState) {
    if (transactionState.allRequestsFailedForSameReason()) {
      this.handleTransactionStatus(transactionState.getTransactionResult());
      this.formOptions.actionFormDialogData.actionDialog$.next({
        result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_ENABLEBUTTONS,
        transactionStateResult: transactionState
      });
    } else {
      // Multiple Transactions ran against this Action Form, going to close the dialog
      // because some transaction passed and some failed.  How does the user know which records
      // failed and which records passed? Will let the list show the feedback!
      this.closeActionFormDialog(transactionState, origTransactionState);
    }
  }

  private closeActionFormDialog(transactionState: LMTransactionState, origTransactionState: LMTransactionState) {
    // close the action form!
    this.formOptions.actionFormDialogData.actionDialog$.next({
      result: LMActionFormDialogResultCode.ACTION_FORM_DIALOG_SAVED,
      transactionStateResult: transactionState
    });

    // origTransactionState is the what the list is listening to
    if (origTransactionState) {
      origTransactionState.actionFormDialogSaved = true;

      for (let i = 0, l = transactionState.completedTransactionList.length; i < l; i++) {
        origTransactionState.completeResult(transactionState.completedTransactionList[i]);
      }
      if (transactionState.cancelledRTConfirmations.length > 0) {
        origTransactionState.cancelledRTConfirmations.push(...transactionState.cancelledRTConfirmations);
      }
      origTransactionState.finish();
    }
  }

  private subscribeToFormChanges() {
    // already exists, so do not add again
    if (this.hasModelStatusSubscription) {
      return;
    }

    this.hasModelStatusSubscription = true;
    const modelStatusSubscription = this.model.statusChanges
      .pipe(debounceTime(500))
      .subscribe((statusEvent: LMModelStatusEvent) => {

        this.allowUpdate = (this.formDataLoadedComplete && statusEvent.isDirty);
        // must wait until dataView is in before making toolbar button visible
        const dataView: LMDataView = this.getDataView();
        if (dataView) {
          this.updateToolbarState(dataView, this.allowUpdate, true);
          this.contentModified.emit(null);
        }

        this.lmLoggerService.log([ this, this.instanceId, 'form.statusChanges', 'end' ]);
      });

    this.subscriptionArray.push(modelStatusSubscription);
  }

  public validateConfigRequiredFields(configRequiredFields: Array<string>): boolean {
    // NOTE: validation of config required fields take place on the client, although if a field is configured for required
    // and is within a visible when (false), the validation will take place on the server as that field will not be a
    // member of the configRequiredFields array

    this.model.resetFieldErrors();

    // 'Field {0} is required by configuration' when field does not have listeners, uses the dialog to display
    // 'Field is required by configuration'     when field has listeners, message displays under the field
    if (configRequiredFields) {
      for (let index = 0, len = configRequiredFields.length; index < len; index++) {
        const bindId = configRequiredFields[index];
        const modelField = this.model.getField(bindId);

        // Compound field combined value isn't guaranteed to be set correctly when member field values are changed inline.
        // so, need to loop thru the member fields to determine if the compound field has a value
        // 1. If the field is a compound field, check that it has some values set.
        // 2. If the field isn't a compound field, only check if blank. If not blank, continue the loop
        if (modelField?.isCompoundField) {
          if (this.compoundFieldHasChangedValues(modelField)) {
            continue;
          }
        } else if (!modelField?.isBlank) {
          continue;
        }

        if (!this.model.setFieldError(bindId, Soho.Locale.translate('FieldRequiredByConfiguration'))) {
          // no listeners, so display with dialog
          const message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('FieldLabelIsRequiredByConfiguration'),
            this.lmFormatUtilService.formatMessageRule(modelField.specLabel, this.model));
          this.lmErrorUtilService.handleError(message, undefined, undefined, Soho.Locale.translate('Error'));
        }
        return false;
      }
    }

    return true;
  }

  private compoundFieldHasChangedValues(field: LMModelField): boolean {
    // safety
    if (!field?.isCompoundField) {
      return field.isBlank;
    }

    if (field.members?.length < 1) {
      return false;
    }

    let hasValue = false;
    field.members.forEach((memberFieldId) => {
      const memberField = this.model.getField(memberFieldId);
      if (memberField !== undefined && memberField !== null && !memberField.isBlank) {
        hasValue = true;
      }
    });

    return hasValue;
  }

  public getUserWebRequestId(): string {
    return  this.isRouterOutletRootComponent ? (this.formSpec ?  this.formSpec.busFormSpec.name : '<NOFORMSPEC>') + '-' +this.getBaseCompId()
      : this.getRouteCompUserWebRequestId();
  }

  public getComponentInfo(additionalInfo?: LMCompInfoAdditionalInfo): LMComponentInfo {
    const pagingUrls: LMFormPagingUrls = (this.model) ? this.model.getPagingUrls() : undefined;
    const formSpec: LMFormSpec = this.formSpec;

    const formRequestUrlTemplate = this.formUrlInfo && this.formUrlInfo.formRequestUrl ? urltemplate.parse(this.formUrlInfo.formRequestUrl) : undefined;
    const formRequestUrl = (formRequestUrlTemplate && this.model) ? formRequestUrlTemplate.expand({ resourceId: this.model.formResourceId }) : '';
    const compositeFormContextFormName: string = (formSpec && formSpec.busFormSpec.formType === 'Composite' && formSpec.busFormSpec.contextForm) ?
      this.formSpec.busFormSpec.contextForm.busFormSpec.name : undefined;
    let message = formSpec ? '' : 'SPEC NOT LOADED YET. ';
    message += this.lmContextService.getContext() ? '' : 'CONTEXT NOT LOADED YET. ';
    message += this.model ? '' : 'MODEL NOT LOADED YET. ';
    const panelSpec: LMCompositePanelSpec = additionalInfo && additionalInfo.panelSpec ? additionalInfo.panelSpec as LMCompositePanelSpec : undefined;
    const contextFormSpec: LMBusFormSpec = additionalInfo && additionalInfo.contextFormSpec ? additionalInfo.contextFormSpec as LMBusFormSpec : undefined;
    message += panelSpec ? 'Has A Panel Spec. ' : '';

    const resourceInfo = this.formSpec && this.formSpec.busFormSpec && this.formSpec.busFormSpec.resourceInfo ? this.formSpec.busFormSpec.resourceInfo : undefined;
    const compConfigInfo: ConfigInfo = {};
    compConfigInfo['personalization'] = formSpec ? formSpec.busFormSpec.personalization : undefined;
    compConfigInfo['configuration'] = formSpec ? formSpec.busFormSpec.configuration : undefined;
    compConfigInfo['configStamp'] = formSpec ? formSpec.busFormSpec.configStamp : 0;
    compConfigInfo['classConfigStamp'] = formSpec ? formSpec.busFormSpec.classConfigStamp : 0;

    const formInfo: LMComponentInfo = {
      status: this.getStatus({ isDirty: this.model ? this.model.isDirty : false, hasError: this.model ? this.model.hasError : false }),
      componentType: 'FORM',
      name: formSpec && formSpec.busClassSpec ? formSpec.busFormSpec.name : undefined,
      userWebRequestId: this.getUserWebRequestId(),
      busClassName: formSpec && formSpec.busClassSpec ? formSpec.busClassSpec.name : undefined,
      module: formSpec ? formSpec.busClassSpec.module : undefined,
      contextFormName: compositeFormContextFormName,
      type: formSpec ? formSpec.busFormSpec.formType : 'Standard',
      developer: formSpec ? formSpec.developer : undefined,
      isWizard: formSpec ? formSpec.busFormSpec.isWizard : undefined,
      panelNavigation: formSpec ? formSpec.busFormSpec.panelNavigation : undefined,
      panelSpec: panelSpec ? panelSpec : undefined,
      contextFormSpec: contextFormSpec ? contextFormSpec : undefined,
      configInfo: compConfigInfo,
      hasConfigAccess: this.lmContextService.hasConfigAccess(),

      lpl: formSpec ? formSpec.busFormSpec.lpl : undefined,
      resourceInfo,
      formRequestUrl,
      tenant: this.lmContextService.getContext() ? this.lmContextService.getContext().dataArea : undefined,

      message: message.length > 0 ? message : undefined,
    };

    if (pagingUrls) {
      formInfo.nextRecordUrl = pagingUrls.nextRecordUrl;
      formInfo.previousRecordUrl = pagingUrls.previousRecordUrl;
      formInfo.reloadRecordUrl = pagingUrls.reloadRecordUrl;
    }

    return formInfo;
  }

  public getComponentPlaceHolder() {
    return this.placeHolder;
  }

  loadComponentState(): void {
    if (this.lmContextService.disablePageState()) {
      return;
    }

    if (!this.useFormState) {
      return;
    }

    if (!this.formUrlInfo) {
      let error = `LMCLIENT UI ALERT: FORMURLINFO ERROR: LMFormComponent.loadComponentState: formUrlInfo is not set for form ${this.formSpec.resourceId}\n`;
      error += `isActionForm ${this.isActionForm}\n`;
      error += `isSearchForm ${this.isSearchForm}\n`;
      error += `isPageContextForm ${this.isPageContextForm}\n`;
      error += `isResponseRequired ${this.isResponseRequired}\n`;
      error += `isMenuLayoutForm ${this.isMenuLayoutForm}\n`;
      error += `isCompactForm ${this.isCompactForm}\n`;
      error += `isSubForm ${this.isSubForm}\n`;

      console.error(error, [ this.formSpec ]);
      this.lmLoggerService.logToServerConsole(error);
      return;
    }

    // for now, lets not load form state if we are in a create situation.
    if (this.lmContextService.getClearPageState() || this.model.isCreateAction) {
      this.clearComponentState(true);
      this.lmContextService.setClearNextPageState(false);
    }

    if (this.formSpec.postRegistration) {
      // fetch the anonymous page state - postRegistration is sticky because it is a url param.
      // example one registered i may leave the screen to do a create from a list and then use the back button to
      // return to the step or wizard.  Because postReg=true is in the url params, this.formSpec.postRegistration
      // will be set to true.
      const anonymousKeyParams: LMFormStateKeyParams = this.buildFormStateKeyParams();
      anonymousKeyParams.actorId = this.formSpec.anonymousId;
      anonymousKeyParams.resourceId = this.buildAnonymousResourceId();
      anonymousKeyParams.routeResourceId = anonymousKeyParams.resourceId;
      const anonymousState = this.lmFormStateService.getFormState(anonymousKeyParams);
      const anonymousStateEmpty = Object.keys(anonymousState).length === 0;
      if (anonymousStateEmpty) { // checks if empty json
        // anonymous state not found or empty, this should mean that the it was already
        // retrieved, used and then deleted.
        this.formStateKeyParams = null;
        this.formState = this.lmFormStateService.getFormState(this.buildFormStateKeyParams());
      } else {
        // found an anonymous state.  The user must of just moved from anonymous to registered,
        // use it and then delete it!
        this.formState = this.lmFormStateService.getFormState(anonymousKeyParams);
        this.lmFormStateService.deleteFormState(anonymousKeyParams);
        this.formStateKeyParams = null;
      }
    } else {
      this.formState = this.lmFormStateService.getFormState(this.buildFormStateKeyParams());
    }

    this.formPersonalization = this.lmFormPersonalizationService.getFormPersonalization(this.buildFormPersonalizationKeyParams());
    this.globalStorageModel = this.lmGlobalStorageService.getItem(this.buildGlobalStorageKeyParams());
  }

  saveComponentState(includeSubComponent?: boolean) {
    if (!this.useFormState) {
      return;
    }
    this.lmLoggerService.time({ id: 'LMForm.saveComponentState() ' + this.instanceId });

    // session storage
    this.lmFormStateService.saveFormState(this.buildFormStateKeyParams(), this.formState);

    // local storage
    this.lmFormPersonalizationService.saveFormPersonalization(this.buildFormPersonalizationKeyParams(), this.formPersonalization);
    if (includeSubComponent && this.formContentComponent) {
      this.formContentComponent.saveComponentState();
    }

    this.lmLoggerService.timeEnd('LMForm.saveComponentState() ' + this.instanceId, [ includeSubComponent ]);
  }

  clearComponentState(includeSubComponent?: boolean): void {
    const routeResourceId = this.formSpec.anonymousId === this.lmContextService.getActorId()
      ? this.buildAnonymousResourceId() : this.formUrlInfo.resource.resourceId;

    this.lmStateHelperService.clearFormComponentState(
      routeResourceId, this.formSpec, includeSubComponent);
  }

  private handleTransactionStatus(result: LMActionResult) {
    // NOTE: internal method - RECURSIVE
    const handleTransactionStatusForFieldId = ( (actionResult: LMActionResult, isSecondPass = false) => {
      let fieldHasObservers = false;

      // safety
      if (actionResult.fieldId) {
        fieldHasObservers = this.formModel.setFieldError(actionResult.fieldId, actionResult.message);

        // LMCLIENT-25416: temporarily log error until LMErrorUtilService dialog can display details
        if (!fieldHasObservers) {
          this.lmLoggerService.error([ actionResult.fieldId, actionResult.message ]);
        }
      }

      if (!fieldHasObservers) {
        // first pass: if a composite form and lazy load, then find the panel the field id is on and activate it
        if (!isSecondPass && actionResult.fieldId && this.canActivatePanel(actionResult.fieldId)) {
          this.zone.runOutsideAngular( () => {
            setTimeout(() => {
              this.zone.run( () => {
                // call the method again to set the error on the field
                handleTransactionStatusForFieldId(actionResult, true);
              });
            }, 1);
          });

        } else {
          this.lmErrorUtilService.handleError(actionResult.message, actionResult.details, actionResult.status);
        }
      }
    });

    // method starts here
    if (result.status === AppConstants.VIEW_EXCEPTION) {
      handleTransactionStatusForFieldId(result);

    } else if (result.status !== AppConstants.STATUS_COMPLETED && result.status !== AppConstants.CONFIRMATION_REQUIRED) {
      // If the status is confirmation required, it may be due to the user cancelling out of runtime confirmation.
      this.lmErrorUtilService.handleError(result.message, result.details, result.status, result.message);
    }
  }

  private openDocumentResource(formButton: LMButtonLayout): void {
    const dataView = this.model.getData();
    const documentResource = new DocumentResource({
      resourceId: formButton.resourceId,
      dataView
    }, '');
    let url: string = this.lmUrlUtilService.buildUrl({
      resource: documentResource
    });

    let option: string;
    if (formButton.hasMimeType) {
      let mimeTypeFieldValue: string;

      if (formButton.mimeTypeField) {
        const mimeTypeField: LMField = dataView.fields[formButton.mimeTypeField];
        mimeTypeFieldValue = mimeTypeField.value as string;
      } else {
        mimeTypeFieldValue = formButton.mimeType;
      }

      if (mimeTypeFieldValue) {
        const urlParams: LMUrlParams = {};
        urlParams['contentType'] = mimeTypeFieldValue;

        url = this.lmUrlUtilService.updateUrlParams(url, urlParams);
        option = (mimeTypeFieldValue === 'application/pdf') ? 'external' : undefined;
      }
    } else if (formButton.fieldId) {
      const documentField = dataView.fields[formButton.fieldId];
      option = (documentField && documentField.mimeType && documentField.mimeType === 'application/pdf') ? 'external' : undefined;
    }
    this.lmGlobalUtilService.navigate(url, null, option);
  }

  public toolbarMoreMenuSettings: SohoPopupMenuOptions = {
    beforeOpen: this.onBeforeFormToolbarMoreMenuOpen,
    attachToBody: true
  };

  public markForCheck() {
    this.changeDetectorRef.markForCheck();
  }

  // --------------------------------------------------------------------------------------------
  // methods for model cache
  /**
   * Will prompt user to apply or discard changes if indicated; otherwise, will auto-apply the changes.
   */
  private checkApplyModelCache(globalStorageModel: LMGlobalStorageModel) {
    if (!globalStorageModel || !globalStorageModel.modelCache) {
      return;
    }

    if (globalStorageModel.modelCache.autoApply === true) {
      // do not display prompt dialog
      this.applyModelCache(globalStorageModel);

    } else {
      // display prompt dialog so user can decide whether to apply or discard changes
      // TODO: dialog message text needs work to differentiate between the Leave/Stay dialog
      this.displayPendingChangesExist().then((applyChanges: boolean) => {
        if (applyChanges) {
          this.applyModelCache(globalStorageModel);
        }
      });
    }
  }

  /**
   * Applies the model cache to current model and will display a toast message if auto apply was not set.
   */
  private applyModelCache(globalStorageModel: LMGlobalStorageModel) {
    this.model.applyCache(globalStorageModel.modelCache);

    // display a toast message only if a prompt was displayed
    if (globalStorageModel.modelCache.autoApply !== true) {
      const message = Soho.Locale.translate('PreviousPendingChangesApplied');
      this.lmGlobalUtilService.displayToastMessage('', message, AppConstants.TRA_ACTION_COMPLETED);
    }
  }

  /**
   * Captures or clears the model cache based on the model state
   * @param autoApply
   */
  private saveModelCache(autoApply?: boolean) {
    if (!this.isModelCacheAllowed) {
      return;
    }

    this.lmLoggerService.time({ id: 'LMForm.saveModelCache() ' + this.instanceId });

    let doSave = false;

    // if dirty or an error, the store the cache
    if (this.model.isDirty || this.model.hasError) {
      this.modelCache = this.model.getCache(autoApply);
      doSave = true;

    } else if (this.modelCache) {
      // all pristine, so remove cache if it exists
      this.modelCache = undefined;
      doSave = true;
    }

    if (doSave) {
      this.saveComponentState(true);

      this.globalStorageModel.lookupFieldId = this.lookupFieldId;
      this.globalStorageModel.modelCache = this.modelCache;
      this.globalStorageModel.timeStamp = Date.now();
      this.globalStorageModel.resourceId = this.model.resourceId;
      this.lmGlobalStorageService.saveItem(this.buildGlobalStorageKeyParams(), this.globalStorageModel);
    }

    this.lmLoggerService.timeEnd('LMForm.saveModelCache() ' + this.instanceId);
  }

  /**
   * Determines which form types will capture and store the model cache
   * @returns
   */
  private get isModelCacheAllowed(): boolean {
    return !(this.isActionForm
      || this.isSearchForm
      || this.isPageContextForm
      || this.isResponseRequired
      || this.isMenuLayoutForm
      || this.isCompactForm
      || this.isSubForm);
  }

  public buildLoadRecordUrl(resourceId: string, actionName: string) {
    const urlCompiledTemplate = urltemplate.parse(this.formUrlInfo.initialDataUrl);
    if (this.fromDataView) {
      if (this.formUrlInfo.sourceResource?.resourceType === 'relation') {
        // related form, send in bus class name for resourceId, or we get an incorrect url
        return urlCompiledTemplate.expand({
          resourceId: this.formSpec.busClassSpec.name,
          sourceResourceId: this.fromDataView.resourceId,
          actionName
        });
      }

      // oto related form resource to another table or oto related form resource to the same table
      return urlCompiledTemplate.expand({
        resourceId: this.fromDataView.resourceId,
        actionName
      });
    }

    return urlCompiledTemplate.expand({ resourceId, actionName });
  }

  public waitForFormToBeReady(): Observable<boolean> {
    return this.lmFormService.waitForFormToBeReady();
  }
}
